import type { PronunciationSyllableAudioEntry } from './types'

// Generated by scripts/sync-audio-cmn.ts. Do not edit by hand.
export const generatedSyllableAudio = [
  { id: '_hm1', audioPath: '/audio/cmn/64k/syllabs/cmn-_hm1.mp3', size: 8414 },
  { id: '_hm2', audioPath: '/audio/cmn/64k/syllabs/cmn-_hm2.mp3', size: 8030 },
  { id: '_hm3', audioPath: '/audio/cmn/64k/syllabs/cmn-_hm3.mp3', size: 11736 },
  { id: '_hm4', audioPath: '/audio/cmn/64k/syllabs/cmn-_hm4.mp3', size: 8798 },
  {
    id: '_hng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_hng1.mp3',
    size: 8800
  },
  {
    id: '_hng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_hng2.mp3',
    size: 8416
  },
  {
    id: '_hng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_hng3.mp3',
    size: 9952
  },
  {
    id: '_hng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_hng4.mp3',
    size: 8800
  },
  {
    id: '_lvan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_lvan1.mp3',
    size: 9954
  },
  {
    id: '_lvan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_lvan2.mp3',
    size: 9954
  },
  {
    id: '_lvan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_lvan3.mp3',
    size: 12066
  },
  {
    id: '_lvan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_lvan4.mp3',
    size: 9186
  },
  { id: '_m1', audioPath: '/audio/cmn/64k/syllabs/cmn-_m1.mp3', size: 9180 },
  { id: '_m2', audioPath: '/audio/cmn/64k/syllabs/cmn-_m2.mp3', size: 8028 },
  { id: '_m3', audioPath: '/audio/cmn/64k/syllabs/cmn-_m3.mp3', size: 11292 },
  { id: '_m4', audioPath: '/audio/cmn/64k/syllabs/cmn-_m4.mp3', size: 8796 },
  { id: '_n1', audioPath: '/audio/cmn/64k/syllabs/cmn-_n1.mp3', size: 8412 },
  { id: '_n2', audioPath: '/audio/cmn/64k/syllabs/cmn-_n2.mp3', size: 8412 },
  { id: '_n3', audioPath: '/audio/cmn/64k/syllabs/cmn-_n3.mp3', size: 12444 },
  { id: '_n4', audioPath: '/audio/cmn/64k/syllabs/cmn-_n4.mp3', size: 8796 },
  { id: '_ng1', audioPath: '/audio/cmn/64k/syllabs/cmn-_ng1.mp3', size: 8798 },
  { id: '_ng2', audioPath: '/audio/cmn/64k/syllabs/cmn-_ng2.mp3', size: 8798 },
  { id: '_ng3', audioPath: '/audio/cmn/64k/syllabs/cmn-_ng3.mp3', size: 13214 },
  { id: '_ng4', audioPath: '/audio/cmn/64k/syllabs/cmn-_ng4.mp3', size: 8798 },
  {
    id: '_nia1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_nia1.mp3',
    size: 9568
  },
  {
    id: '_nia2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_nia2.mp3',
    size: 9568
  },
  {
    id: '_nia3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_nia3.mp3',
    size: 12064
  },
  {
    id: '_nia4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-_nia4.mp3',
    size: 9184
  },
  { id: 'a1', audioPath: '/audio/cmn/64k/syllabs/cmn-a1.mp3', size: 8794 },
  { id: 'a2', audioPath: '/audio/cmn/64k/syllabs/cmn-a2.mp3', size: 8794 },
  { id: 'a3', audioPath: '/audio/cmn/64k/syllabs/cmn-a3.mp3', size: 10330 },
  { id: 'a4', audioPath: '/audio/cmn/64k/syllabs/cmn-a4.mp3', size: 8410 },
  { id: 'a5', audioPath: '/audio/cmn/64k/syllabs/cmn-a5.mp3', size: 15130 },
  { id: 'ai1', audioPath: '/audio/cmn/64k/syllabs/cmn-ai1.mp3', size: 8796 },
  { id: 'ai2', audioPath: '/audio/cmn/64k/syllabs/cmn-ai2.mp3', size: 8796 },
  { id: 'ai3', audioPath: '/audio/cmn/64k/syllabs/cmn-ai3.mp3', size: 9948 },
  { id: 'ai4', audioPath: '/audio/cmn/64k/syllabs/cmn-ai4.mp3', size: 8028 },
  { id: 'ai5', audioPath: '/audio/cmn/64k/syllabs/cmn-ai5.mp3', size: 26460 },
  { id: 'an1', audioPath: '/audio/cmn/64k/syllabs/cmn-an1.mp3', size: 9180 },
  { id: 'an2', audioPath: '/audio/cmn/64k/syllabs/cmn-an2.mp3', size: 9180 },
  { id: 'an3', audioPath: '/audio/cmn/64k/syllabs/cmn-an3.mp3', size: 11292 },
  { id: 'an4', audioPath: '/audio/cmn/64k/syllabs/cmn-an4.mp3', size: 8412 },
  { id: 'an5', audioPath: '/audio/cmn/64k/syllabs/cmn-an5.mp3', size: 19548 },
  { id: 'ang1', audioPath: '/audio/cmn/64k/syllabs/cmn-ang1.mp3', size: 8798 },
  { id: 'ang2', audioPath: '/audio/cmn/64k/syllabs/cmn-ang2.mp3', size: 9182 },
  { id: 'ang3', audioPath: '/audio/cmn/64k/syllabs/cmn-ang3.mp3', size: 11294 },
  { id: 'ang4', audioPath: '/audio/cmn/64k/syllabs/cmn-ang4.mp3', size: 8414 },
  { id: 'ang5', audioPath: '/audio/cmn/64k/syllabs/cmn-ang5.mp3', size: 22814 },
  { id: 'ao1', audioPath: '/audio/cmn/64k/syllabs/cmn-ao1.mp3', size: 8412 },
  { id: 'ao2', audioPath: '/audio/cmn/64k/syllabs/cmn-ao2.mp3', size: 8412 },
  { id: 'ao3', audioPath: '/audio/cmn/64k/syllabs/cmn-ao3.mp3', size: 10716 },
  { id: 'ao4', audioPath: '/audio/cmn/64k/syllabs/cmn-ao4.mp3', size: 8412 },
  { id: 'ao5', audioPath: '/audio/cmn/64k/syllabs/cmn-ao5.mp3', size: 15516 },
  { id: 'ba1', audioPath: '/audio/cmn/64k/syllabs/cmn-ba1.mp3', size: 8796 },
  { id: 'ba2', audioPath: '/audio/cmn/64k/syllabs/cmn-ba2.mp3', size: 8412 },
  { id: 'ba3', audioPath: '/audio/cmn/64k/syllabs/cmn-ba3.mp3', size: 10332 },
  { id: 'ba4', audioPath: '/audio/cmn/64k/syllabs/cmn-ba4.mp3', size: 8412 },
  { id: 'ba5', audioPath: '/audio/cmn/64k/syllabs/cmn-ba5.mp3', size: 40860 },
  { id: 'bai1', audioPath: '/audio/cmn/64k/syllabs/cmn-bai1.mp3', size: 8798 },
  { id: 'bai2', audioPath: '/audio/cmn/64k/syllabs/cmn-bai2.mp3', size: 8798 },
  { id: 'bai3', audioPath: '/audio/cmn/64k/syllabs/cmn-bai3.mp3', size: 10718 },
  { id: 'bai4', audioPath: '/audio/cmn/64k/syllabs/cmn-bai4.mp3', size: 8414 },
  { id: 'bai5', audioPath: '/audio/cmn/64k/syllabs/cmn-bai5.mp3', size: 9950 },
  { id: 'ban1', audioPath: '/audio/cmn/64k/syllabs/cmn-ban1.mp3', size: 8798 },
  { id: 'ban2', audioPath: '/audio/cmn/64k/syllabs/cmn-ban2.mp3', size: 9182 },
  { id: 'ban3', audioPath: '/audio/cmn/64k/syllabs/cmn-ban3.mp3', size: 10718 },
  { id: 'ban4', audioPath: '/audio/cmn/64k/syllabs/cmn-ban4.mp3', size: 8030 },
  { id: 'ban5', audioPath: '/audio/cmn/64k/syllabs/cmn-ban5.mp3', size: 41630 },
  {
    id: 'bang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bang1.mp3',
    size: 8800
  },
  {
    id: 'bang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bang2.mp3',
    size: 8032
  },
  {
    id: 'bang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bang3.mp3',
    size: 10720
  },
  {
    id: 'bang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bang4.mp3',
    size: 8032
  },
  {
    id: 'bang5',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bang5.mp3',
    size: 14752
  },
  { id: 'bao1', audioPath: '/audio/cmn/64k/syllabs/cmn-bao1.mp3', size: 8414 },
  { id: 'bao2', audioPath: '/audio/cmn/64k/syllabs/cmn-bao2.mp3', size: 9182 },
  { id: 'bao3', audioPath: '/audio/cmn/64k/syllabs/cmn-bao3.mp3', size: 10334 },
  { id: 'bao4', audioPath: '/audio/cmn/64k/syllabs/cmn-bao4.mp3', size: 8414 },
  { id: 'bao5', audioPath: '/audio/cmn/64k/syllabs/cmn-bao5.mp3', size: 29918 },
  { id: 'bei1', audioPath: '/audio/cmn/64k/syllabs/cmn-bei1.mp3', size: 9182 },
  { id: 'bei2', audioPath: '/audio/cmn/64k/syllabs/cmn-bei2.mp3', size: 8414 },
  { id: 'bei3', audioPath: '/audio/cmn/64k/syllabs/cmn-bei3.mp3', size: 10334 },
  { id: 'bei4', audioPath: '/audio/cmn/64k/syllabs/cmn-bei4.mp3', size: 8414 },
  { id: 'bei5', audioPath: '/audio/cmn/64k/syllabs/cmn-bei5.mp3', size: 35294 },
  { id: 'ben1', audioPath: '/audio/cmn/64k/syllabs/cmn-ben1.mp3', size: 8030 },
  { id: 'ben2', audioPath: '/audio/cmn/64k/syllabs/cmn-ben2.mp3', size: 9182 },
  { id: 'ben3', audioPath: '/audio/cmn/64k/syllabs/cmn-ben3.mp3', size: 11294 },
  { id: 'ben4', audioPath: '/audio/cmn/64k/syllabs/cmn-ben4.mp3', size: 8414 },
  { id: 'ben5', audioPath: '/audio/cmn/64k/syllabs/cmn-ben5.mp3', size: 29150 },
  {
    id: 'beng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-beng1.mp3',
    size: 8800
  },
  {
    id: 'beng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-beng2.mp3',
    size: 8800
  },
  {
    id: 'beng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-beng3.mp3',
    size: 11296
  },
  {
    id: 'beng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-beng4.mp3',
    size: 8416
  },
  {
    id: 'beng5',
    audioPath: '/audio/cmn/64k/syllabs/cmn-beng5.mp3',
    size: 28384
  },
  { id: 'bi1', audioPath: '/audio/cmn/64k/syllabs/cmn-bi1.mp3', size: 8412 },
  { id: 'bi2', audioPath: '/audio/cmn/64k/syllabs/cmn-bi2.mp3', size: 8412 },
  { id: 'bi3', audioPath: '/audio/cmn/64k/syllabs/cmn-bi3.mp3', size: 10332 },
  { id: 'bi4', audioPath: '/audio/cmn/64k/syllabs/cmn-bi4.mp3', size: 8028 },
  { id: 'bi5', audioPath: '/audio/cmn/64k/syllabs/cmn-bi5.mp3', size: 11676 },
  {
    id: 'bian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bian1.mp3',
    size: 8800
  },
  {
    id: 'bian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bian2.mp3',
    size: 9184
  },
  {
    id: 'bian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bian3.mp3',
    size: 9952
  },
  {
    id: 'bian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bian4.mp3',
    size: 8416
  },
  {
    id: 'bian5',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bian5.mp3',
    size: 13216
  },
  {
    id: 'biao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-biao1.mp3',
    size: 9184
  },
  {
    id: 'biao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-biao2.mp3',
    size: 9184
  },
  {
    id: 'biao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-biao3.mp3',
    size: 10720
  },
  {
    id: 'biao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-biao4.mp3',
    size: 8416
  },
  {
    id: 'biao5',
    audioPath: '/audio/cmn/64k/syllabs/cmn-biao5.mp3',
    size: 9952
  },
  { id: 'bie1', audioPath: '/audio/cmn/64k/syllabs/cmn-bie1.mp3', size: 8030 },
  { id: 'bie2', audioPath: '/audio/cmn/64k/syllabs/cmn-bie2.mp3', size: 9566 },
  { id: 'bie3', audioPath: '/audio/cmn/64k/syllabs/cmn-bie3.mp3', size: 10718 },
  { id: 'bie4', audioPath: '/audio/cmn/64k/syllabs/cmn-bie4.mp3', size: 8030 },
  { id: 'bie5', audioPath: '/audio/cmn/64k/syllabs/cmn-bie5.mp3', size: 7646 },
  { id: 'bin1', audioPath: '/audio/cmn/64k/syllabs/cmn-bin1.mp3', size: 8798 },
  { id: 'bin2', audioPath: '/audio/cmn/64k/syllabs/cmn-bin2.mp3', size: 8798 },
  { id: 'bin3', audioPath: '/audio/cmn/64k/syllabs/cmn-bin3.mp3', size: 10334 },
  { id: 'bin4', audioPath: '/audio/cmn/64k/syllabs/cmn-bin4.mp3', size: 8414 },
  { id: 'bin5', audioPath: '/audio/cmn/64k/syllabs/cmn-bin5.mp3', size: 18782 },
  {
    id: 'bing1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bing1.mp3',
    size: 9184
  },
  {
    id: 'bing2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bing2.mp3',
    size: 9184
  },
  {
    id: 'bing3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bing3.mp3',
    size: 8800
  },
  {
    id: 'bing4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bing4.mp3',
    size: 8416
  },
  {
    id: 'bing5',
    audioPath: '/audio/cmn/64k/syllabs/cmn-bing5.mp3',
    size: 22432
  },
  { id: 'bo1', audioPath: '/audio/cmn/64k/syllabs/cmn-bo1.mp3', size: 8412 },
  { id: 'bo2', audioPath: '/audio/cmn/64k/syllabs/cmn-bo2.mp3', size: 8412 },
  { id: 'bo3', audioPath: '/audio/cmn/64k/syllabs/cmn-bo3.mp3', size: 10332 },
  { id: 'bo4', audioPath: '/audio/cmn/64k/syllabs/cmn-bo4.mp3', size: 8412 },
  { id: 'bu1', audioPath: '/audio/cmn/64k/syllabs/cmn-bu1.mp3', size: 8028 },
  { id: 'bu2', audioPath: '/audio/cmn/64k/syllabs/cmn-bu2.mp3', size: 9180 },
  { id: 'bu3', audioPath: '/audio/cmn/64k/syllabs/cmn-bu3.mp3', size: 9948 },
  { id: 'bu4', audioPath: '/audio/cmn/64k/syllabs/cmn-bu4.mp3', size: 8028 },
  { id: 'ca1', audioPath: '/audio/cmn/64k/syllabs/cmn-ca1.mp3', size: 9180 },
  { id: 'ca2', audioPath: '/audio/cmn/64k/syllabs/cmn-ca2.mp3', size: 8412 },
  { id: 'ca3', audioPath: '/audio/cmn/64k/syllabs/cmn-ca3.mp3', size: 11676 },
  { id: 'ca4', audioPath: '/audio/cmn/64k/syllabs/cmn-ca4.mp3', size: 9180 },
  { id: 'cai1', audioPath: '/audio/cmn/64k/syllabs/cmn-cai1.mp3', size: 8798 },
  { id: 'cai2', audioPath: '/audio/cmn/64k/syllabs/cmn-cai2.mp3', size: 9566 },
  { id: 'cai3', audioPath: '/audio/cmn/64k/syllabs/cmn-cai3.mp3', size: 9182 },
  { id: 'cai4', audioPath: '/audio/cmn/64k/syllabs/cmn-cai4.mp3', size: 9182 },
  { id: 'can1', audioPath: '/audio/cmn/64k/syllabs/cmn-can1.mp3', size: 8798 },
  { id: 'can2', audioPath: '/audio/cmn/64k/syllabs/cmn-can2.mp3', size: 9950 },
  { id: 'can3', audioPath: '/audio/cmn/64k/syllabs/cmn-can3.mp3', size: 11294 },
  { id: 'can4', audioPath: '/audio/cmn/64k/syllabs/cmn-can4.mp3', size: 9182 },
  {
    id: 'cang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cang1.mp3',
    size: 9568
  },
  {
    id: 'cang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cang2.mp3',
    size: 9952
  },
  {
    id: 'cang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cang3.mp3',
    size: 11296
  },
  {
    id: 'cang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cang4.mp3',
    size: 9184
  },
  { id: 'cao1', audioPath: '/audio/cmn/64k/syllabs/cmn-cao1.mp3', size: 9566 },
  { id: 'cao2', audioPath: '/audio/cmn/64k/syllabs/cmn-cao2.mp3', size: 9566 },
  { id: 'cao3', audioPath: '/audio/cmn/64k/syllabs/cmn-cao3.mp3', size: 10718 },
  { id: 'cao4', audioPath: '/audio/cmn/64k/syllabs/cmn-cao4.mp3', size: 9182 },
  { id: 'ce1', audioPath: '/audio/cmn/64k/syllabs/cmn-ce1.mp3', size: 9564 },
  { id: 'ce2', audioPath: '/audio/cmn/64k/syllabs/cmn-ce2.mp3', size: 9948 },
  { id: 'ce3', audioPath: '/audio/cmn/64k/syllabs/cmn-ce3.mp3', size: 10332 },
  { id: 'ce4', audioPath: '/audio/cmn/64k/syllabs/cmn-ce4.mp3', size: 8796 },
  { id: 'cei1', audioPath: '/audio/cmn/64k/syllabs/cmn-cei1.mp3', size: 9950 },
  { id: 'cei2', audioPath: '/audio/cmn/64k/syllabs/cmn-cei2.mp3', size: 9566 },
  { id: 'cei3', audioPath: '/audio/cmn/64k/syllabs/cmn-cei3.mp3', size: 10718 },
  { id: 'cei4', audioPath: '/audio/cmn/64k/syllabs/cmn-cei4.mp3', size: 8798 },
  { id: 'cen1', audioPath: '/audio/cmn/64k/syllabs/cmn-cen1.mp3', size: 8798 },
  { id: 'cen2', audioPath: '/audio/cmn/64k/syllabs/cmn-cen2.mp3', size: 9950 },
  { id: 'cen3', audioPath: '/audio/cmn/64k/syllabs/cmn-cen3.mp3', size: 10334 },
  { id: 'cen4', audioPath: '/audio/cmn/64k/syllabs/cmn-cen4.mp3', size: 9182 },
  {
    id: 'ceng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ceng1.mp3',
    size: 9952
  },
  {
    id: 'ceng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ceng2.mp3',
    size: 8800
  },
  {
    id: 'ceng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ceng3.mp3',
    size: 9952
  },
  {
    id: 'ceng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ceng4.mp3',
    size: 8416
  },
  { id: 'cha1', audioPath: '/audio/cmn/64k/syllabs/cmn-cha1.mp3', size: 9566 },
  { id: 'cha2', audioPath: '/audio/cmn/64k/syllabs/cmn-cha2.mp3', size: 10334 },
  { id: 'cha3', audioPath: '/audio/cmn/64k/syllabs/cmn-cha3.mp3', size: 10718 },
  { id: 'cha4', audioPath: '/audio/cmn/64k/syllabs/cmn-cha4.mp3', size: 9566 },
  {
    id: 'chai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chai1.mp3',
    size: 9952
  },
  {
    id: 'chai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chai2.mp3',
    size: 10336
  },
  {
    id: 'chai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chai3.mp3',
    size: 8416
  },
  {
    id: 'chai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chai4.mp3',
    size: 8416
  },
  {
    id: 'chan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chan1.mp3',
    size: 9568
  },
  {
    id: 'chan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chan2.mp3',
    size: 10336
  },
  {
    id: 'chan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chan3.mp3',
    size: 11296
  },
  {
    id: 'chan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chan4.mp3',
    size: 9568
  },
  {
    id: 'chang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chang1.mp3',
    size: 9954
  },
  {
    id: 'chang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chang2.mp3',
    size: 9186
  },
  {
    id: 'chang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chang3.mp3',
    size: 11682
  },
  {
    id: 'chang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chang4.mp3',
    size: 9186
  },
  {
    id: 'chao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chao1.mp3',
    size: 9568
  },
  {
    id: 'chao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chao2.mp3',
    size: 10336
  },
  {
    id: 'chao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chao3.mp3',
    size: 11296
  },
  {
    id: 'chao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chao4.mp3',
    size: 9184
  },
  { id: 'che1', audioPath: '/audio/cmn/64k/syllabs/cmn-che1.mp3', size: 9182 },
  { id: 'che2', audioPath: '/audio/cmn/64k/syllabs/cmn-che2.mp3', size: 8798 },
  { id: 'che3', audioPath: '/audio/cmn/64k/syllabs/cmn-che3.mp3', size: 9566 },
  { id: 'che4', audioPath: '/audio/cmn/64k/syllabs/cmn-che4.mp3', size: 9566 },
  {
    id: 'chen1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chen1.mp3',
    size: 9568
  },
  {
    id: 'chen2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chen2.mp3',
    size: 9952
  },
  {
    id: 'chen3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chen3.mp3',
    size: 9184
  },
  {
    id: 'chen4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chen4.mp3',
    size: 8800
  },
  {
    id: 'cheng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cheng1.mp3',
    size: 8418
  },
  {
    id: 'cheng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cheng2.mp3',
    size: 9954
  },
  {
    id: 'cheng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cheng3.mp3',
    size: 10722
  },
  {
    id: 'cheng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cheng4.mp3',
    size: 9954
  },
  { id: 'chi1', audioPath: '/audio/cmn/64k/syllabs/cmn-chi1.mp3', size: 8798 },
  { id: 'chi2', audioPath: '/audio/cmn/64k/syllabs/cmn-chi2.mp3', size: 9566 },
  { id: 'chi3', audioPath: '/audio/cmn/64k/syllabs/cmn-chi3.mp3', size: 11294 },
  { id: 'chi4', audioPath: '/audio/cmn/64k/syllabs/cmn-chi4.mp3', size: 8414 },
  {
    id: 'chong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chong1.mp3',
    size: 9186
  },
  {
    id: 'chong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chong2.mp3',
    size: 9186
  },
  {
    id: 'chong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chong3.mp3',
    size: 10338
  },
  {
    id: 'chong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chong4.mp3',
    size: 9570
  },
  {
    id: 'chou1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chou1.mp3',
    size: 8416
  },
  {
    id: 'chou2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chou2.mp3',
    size: 9568
  },
  {
    id: 'chou3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chou3.mp3',
    size: 10720
  },
  {
    id: 'chou4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chou4.mp3',
    size: 9184
  },
  { id: 'chu1', audioPath: '/audio/cmn/64k/syllabs/cmn-chu1.mp3', size: 8030 },
  { id: 'chu2', audioPath: '/audio/cmn/64k/syllabs/cmn-chu2.mp3', size: 9566 },
  { id: 'chu3', audioPath: '/audio/cmn/64k/syllabs/cmn-chu3.mp3', size: 11294 },
  { id: 'chu4', audioPath: '/audio/cmn/64k/syllabs/cmn-chu4.mp3', size: 9950 },
  {
    id: 'chua1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chua1.mp3',
    size: 9568
  },
  {
    id: 'chua2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chua2.mp3',
    size: 10336
  },
  {
    id: 'chua3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chua3.mp3',
    size: 12064
  },
  {
    id: 'chua4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chua4.mp3',
    size: 9184
  },
  {
    id: 'chuai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuai1.mp3',
    size: 8034
  },
  {
    id: 'chuai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuai2.mp3',
    size: 9186
  },
  {
    id: 'chuai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuai3.mp3',
    size: 9954
  },
  {
    id: 'chuai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuai4.mp3',
    size: 8802
  },
  {
    id: 'chuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuan1.mp3',
    size: 8418
  },
  {
    id: 'chuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuan2.mp3',
    size: 8418
  },
  {
    id: 'chuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuan3.mp3',
    size: 10722
  },
  {
    id: 'chuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuan4.mp3',
    size: 9186
  },
  {
    id: 'chuang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuang1.mp3',
    size: 8420
  },
  {
    id: 'chuang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuang2.mp3',
    size: 9572
  },
  {
    id: 'chuang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuang3.mp3',
    size: 10724
  },
  {
    id: 'chuang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuang4.mp3',
    size: 8804
  },
  {
    id: 'chui1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chui1.mp3',
    size: 8032
  },
  {
    id: 'chui2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chui2.mp3',
    size: 9184
  },
  {
    id: 'chui3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chui3.mp3',
    size: 9952
  },
  {
    id: 'chui4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chui4.mp3',
    size: 9568
  },
  {
    id: 'chun1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chun1.mp3',
    size: 9952
  },
  {
    id: 'chun2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chun2.mp3',
    size: 10336
  },
  {
    id: 'chun3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chun3.mp3',
    size: 10720
  },
  {
    id: 'chun4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chun4.mp3',
    size: 9184
  },
  {
    id: 'chuo1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuo1.mp3',
    size: 8416
  },
  {
    id: 'chuo2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuo2.mp3',
    size: 9184
  },
  {
    id: 'chuo3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuo3.mp3',
    size: 11296
  },
  {
    id: 'chuo4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-chuo4.mp3',
    size: 9568
  },
  { id: 'ci1', audioPath: '/audio/cmn/64k/syllabs/cmn-ci1.mp3', size: 9564 },
  { id: 'ci2', audioPath: '/audio/cmn/64k/syllabs/cmn-ci2.mp3', size: 9948 },
  { id: 'ci3', audioPath: '/audio/cmn/64k/syllabs/cmn-ci3.mp3', size: 12060 },
  { id: 'ci4', audioPath: '/audio/cmn/64k/syllabs/cmn-ci4.mp3', size: 9180 },
  {
    id: 'cong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cong1.mp3',
    size: 10336
  },
  {
    id: 'cong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cong2.mp3',
    size: 9568
  },
  {
    id: 'cong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cong3.mp3',
    size: 12064
  },
  {
    id: 'cong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cong4.mp3',
    size: 9184
  },
  { id: 'cou1', audioPath: '/audio/cmn/64k/syllabs/cmn-cou1.mp3', size: 9182 },
  { id: 'cou2', audioPath: '/audio/cmn/64k/syllabs/cmn-cou2.mp3', size: 9566 },
  { id: 'cou3', audioPath: '/audio/cmn/64k/syllabs/cmn-cou3.mp3', size: 10334 },
  { id: 'cou4', audioPath: '/audio/cmn/64k/syllabs/cmn-cou4.mp3', size: 8798 },
  { id: 'cu1', audioPath: '/audio/cmn/64k/syllabs/cmn-cu1.mp3', size: 9180 },
  { id: 'cu2', audioPath: '/audio/cmn/64k/syllabs/cmn-cu2.mp3', size: 9948 },
  { id: 'cu3', audioPath: '/audio/cmn/64k/syllabs/cmn-cu3.mp3', size: 11292 },
  { id: 'cu4', audioPath: '/audio/cmn/64k/syllabs/cmn-cu4.mp3', size: 8796 },
  {
    id: 'cuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cuan1.mp3',
    size: 10336
  },
  {
    id: 'cuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cuan2.mp3',
    size: 10336
  },
  {
    id: 'cuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cuan3.mp3',
    size: 12448
  },
  {
    id: 'cuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-cuan4.mp3',
    size: 9568
  },
  { id: 'cui1', audioPath: '/audio/cmn/64k/syllabs/cmn-cui1.mp3', size: 10334 },
  { id: 'cui2', audioPath: '/audio/cmn/64k/syllabs/cmn-cui2.mp3', size: 9182 },
  { id: 'cui3', audioPath: '/audio/cmn/64k/syllabs/cmn-cui3.mp3', size: 12062 },
  { id: 'cui4', audioPath: '/audio/cmn/64k/syllabs/cmn-cui4.mp3', size: 9182 },
  { id: 'cun1', audioPath: '/audio/cmn/64k/syllabs/cmn-cun1.mp3', size: 9182 },
  { id: 'cun2', audioPath: '/audio/cmn/64k/syllabs/cmn-cun2.mp3', size: 10718 },
  { id: 'cun3', audioPath: '/audio/cmn/64k/syllabs/cmn-cun3.mp3', size: 11294 },
  { id: 'cun4', audioPath: '/audio/cmn/64k/syllabs/cmn-cun4.mp3', size: 9566 },
  { id: 'cuo1', audioPath: '/audio/cmn/64k/syllabs/cmn-cuo1.mp3', size: 9182 },
  { id: 'cuo2', audioPath: '/audio/cmn/64k/syllabs/cmn-cuo2.mp3', size: 9950 },
  { id: 'cuo3', audioPath: '/audio/cmn/64k/syllabs/cmn-cuo3.mp3', size: 12062 },
  { id: 'cuo4', audioPath: '/audio/cmn/64k/syllabs/cmn-cuo4.mp3', size: 8030 },
  { id: 'da1', audioPath: '/audio/cmn/64k/syllabs/cmn-da1.mp3', size: 8796 },
  { id: 'da2', audioPath: '/audio/cmn/64k/syllabs/cmn-da2.mp3', size: 9180 },
  { id: 'da3', audioPath: '/audio/cmn/64k/syllabs/cmn-da3.mp3', size: 9948 },
  { id: 'da4', audioPath: '/audio/cmn/64k/syllabs/cmn-da4.mp3', size: 8028 },
  { id: 'dai1', audioPath: '/audio/cmn/64k/syllabs/cmn-dai1.mp3', size: 8798 },
  { id: 'dai2', audioPath: '/audio/cmn/64k/syllabs/cmn-dai2.mp3', size: 9182 },
  { id: 'dai3', audioPath: '/audio/cmn/64k/syllabs/cmn-dai3.mp3', size: 10334 },
  { id: 'dai4', audioPath: '/audio/cmn/64k/syllabs/cmn-dai4.mp3', size: 8030 },
  { id: 'dan1', audioPath: '/audio/cmn/64k/syllabs/cmn-dan1.mp3', size: 9182 },
  { id: 'dan2', audioPath: '/audio/cmn/64k/syllabs/cmn-dan2.mp3', size: 8030 },
  { id: 'dan3', audioPath: '/audio/cmn/64k/syllabs/cmn-dan3.mp3', size: 10334 },
  { id: 'dan4', audioPath: '/audio/cmn/64k/syllabs/cmn-dan4.mp3', size: 8030 },
  {
    id: 'dang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dang1.mp3',
    size: 9568
  },
  {
    id: 'dang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dang2.mp3',
    size: 9184
  },
  {
    id: 'dang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dang3.mp3',
    size: 11296
  },
  {
    id: 'dang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dang4.mp3',
    size: 8032
  },
  { id: 'dao1', audioPath: '/audio/cmn/64k/syllabs/cmn-dao1.mp3', size: 8798 },
  { id: 'dao2', audioPath: '/audio/cmn/64k/syllabs/cmn-dao2.mp3', size: 9182 },
  { id: 'dao3', audioPath: '/audio/cmn/64k/syllabs/cmn-dao3.mp3', size: 10334 },
  { id: 'dao4', audioPath: '/audio/cmn/64k/syllabs/cmn-dao4.mp3', size: 8414 },
  { id: 'de1', audioPath: '/audio/cmn/64k/syllabs/cmn-de1.mp3', size: 8796 },
  { id: 'de2', audioPath: '/audio/cmn/64k/syllabs/cmn-de2.mp3', size: 8796 },
  { id: 'de3', audioPath: '/audio/cmn/64k/syllabs/cmn-de3.mp3', size: 9948 },
  { id: 'de4', audioPath: '/audio/cmn/64k/syllabs/cmn-de4.mp3', size: 8412 },
  { id: 'dei1', audioPath: '/audio/cmn/64k/syllabs/cmn-dei1.mp3', size: 8798 },
  { id: 'dei2', audioPath: '/audio/cmn/64k/syllabs/cmn-dei2.mp3', size: 9566 },
  { id: 'dei3', audioPath: '/audio/cmn/64k/syllabs/cmn-dei3.mp3', size: 9950 },
  { id: 'dei4', audioPath: '/audio/cmn/64k/syllabs/cmn-dei4.mp3', size: 8030 },
  { id: 'den1', audioPath: '/audio/cmn/64k/syllabs/cmn-den1.mp3', size: 9182 },
  { id: 'den2', audioPath: '/audio/cmn/64k/syllabs/cmn-den2.mp3', size: 9182 },
  { id: 'den3', audioPath: '/audio/cmn/64k/syllabs/cmn-den3.mp3', size: 10334 },
  { id: 'den4', audioPath: '/audio/cmn/64k/syllabs/cmn-den4.mp3', size: 8030 },
  {
    id: 'deng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-deng1.mp3',
    size: 8416
  },
  {
    id: 'deng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-deng2.mp3',
    size: 8800
  },
  {
    id: 'deng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-deng3.mp3',
    size: 10720
  },
  {
    id: 'deng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-deng4.mp3',
    size: 8416
  },
  { id: 'di1', audioPath: '/audio/cmn/64k/syllabs/cmn-di1.mp3', size: 9180 },
  { id: 'di2', audioPath: '/audio/cmn/64k/syllabs/cmn-di2.mp3', size: 8796 },
  { id: 'di3', audioPath: '/audio/cmn/64k/syllabs/cmn-di3.mp3', size: 9948 },
  { id: 'di4', audioPath: '/audio/cmn/64k/syllabs/cmn-di4.mp3', size: 8412 },
  { id: 'dia1', audioPath: '/audio/cmn/64k/syllabs/cmn-dia1.mp3', size: 9182 },
  { id: 'dia2', audioPath: '/audio/cmn/64k/syllabs/cmn-dia2.mp3', size: 10718 },
  { id: 'dia3', audioPath: '/audio/cmn/64k/syllabs/cmn-dia3.mp3', size: 11294 },
  { id: 'dia4', audioPath: '/audio/cmn/64k/syllabs/cmn-dia4.mp3', size: 8030 },
  {
    id: 'dian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dian1.mp3',
    size: 9952
  },
  {
    id: 'dian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dian2.mp3',
    size: 9952
  },
  {
    id: 'dian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dian3.mp3',
    size: 10720
  },
  {
    id: 'dian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dian4.mp3',
    size: 8032
  },
  {
    id: 'diao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-diao1.mp3',
    size: 9184
  },
  {
    id: 'diao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-diao2.mp3',
    size: 10336
  },
  {
    id: 'diao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-diao3.mp3',
    size: 11680
  },
  {
    id: 'diao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-diao4.mp3',
    size: 8416
  },
  { id: 'die1', audioPath: '/audio/cmn/64k/syllabs/cmn-die1.mp3', size: 9566 },
  { id: 'die2', audioPath: '/audio/cmn/64k/syllabs/cmn-die2.mp3', size: 8414 },
  { id: 'die3', audioPath: '/audio/cmn/64k/syllabs/cmn-die3.mp3', size: 10334 },
  { id: 'die4', audioPath: '/audio/cmn/64k/syllabs/cmn-die4.mp3', size: 8414 },
  {
    id: 'ding1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ding1.mp3',
    size: 8032
  },
  {
    id: 'ding2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ding2.mp3',
    size: 9184
  },
  {
    id: 'ding3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ding3.mp3',
    size: 10336
  },
  {
    id: 'ding4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ding4.mp3',
    size: 8800
  },
  { id: 'diu1', audioPath: '/audio/cmn/64k/syllabs/cmn-diu1.mp3', size: 9182 },
  { id: 'diu2', audioPath: '/audio/cmn/64k/syllabs/cmn-diu2.mp3', size: 9182 },
  { id: 'diu3', audioPath: '/audio/cmn/64k/syllabs/cmn-diu3.mp3', size: 11678 },
  { id: 'diu4', audioPath: '/audio/cmn/64k/syllabs/cmn-diu4.mp3', size: 8030 },
  {
    id: 'dong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dong1.mp3',
    size: 8800
  },
  {
    id: 'dong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dong2.mp3',
    size: 9184
  },
  {
    id: 'dong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dong3.mp3',
    size: 10720
  },
  {
    id: 'dong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-dong4.mp3',
    size: 8416
  },
  { id: 'dou1', audioPath: '/audio/cmn/64k/syllabs/cmn-dou1.mp3', size: 8798 },
  { id: 'dou2', audioPath: '/audio/cmn/64k/syllabs/cmn-dou2.mp3', size: 8798 },
  { id: 'dou3', audioPath: '/audio/cmn/64k/syllabs/cmn-dou3.mp3', size: 9182 },
  { id: 'dou4', audioPath: '/audio/cmn/64k/syllabs/cmn-dou4.mp3', size: 8030 },
  { id: 'du1', audioPath: '/audio/cmn/64k/syllabs/cmn-du1.mp3', size: 8796 },
  { id: 'du2', audioPath: '/audio/cmn/64k/syllabs/cmn-du2.mp3', size: 9180 },
  { id: 'du3', audioPath: '/audio/cmn/64k/syllabs/cmn-du3.mp3', size: 10332 },
  { id: 'du4', audioPath: '/audio/cmn/64k/syllabs/cmn-du4.mp3', size: 8412 },
  {
    id: 'duan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-duan1.mp3',
    size: 9952
  },
  {
    id: 'duan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-duan2.mp3',
    size: 9184
  },
  {
    id: 'duan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-duan3.mp3',
    size: 10720
  },
  {
    id: 'duan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-duan4.mp3',
    size: 8416
  },
  { id: 'dui1', audioPath: '/audio/cmn/64k/syllabs/cmn-dui1.mp3', size: 9182 },
  { id: 'dui2', audioPath: '/audio/cmn/64k/syllabs/cmn-dui2.mp3', size: 8414 },
  { id: 'dui3', audioPath: '/audio/cmn/64k/syllabs/cmn-dui3.mp3', size: 9950 },
  { id: 'dui4', audioPath: '/audio/cmn/64k/syllabs/cmn-dui4.mp3', size: 8414 },
  { id: 'dun1', audioPath: '/audio/cmn/64k/syllabs/cmn-dun1.mp3', size: 8414 },
  { id: 'dun2', audioPath: '/audio/cmn/64k/syllabs/cmn-dun2.mp3', size: 8798 },
  { id: 'dun3', audioPath: '/audio/cmn/64k/syllabs/cmn-dun3.mp3', size: 9566 },
  { id: 'dun4', audioPath: '/audio/cmn/64k/syllabs/cmn-dun4.mp3', size: 8414 },
  { id: 'duo1', audioPath: '/audio/cmn/64k/syllabs/cmn-duo1.mp3', size: 8798 },
  { id: 'duo2', audioPath: '/audio/cmn/64k/syllabs/cmn-duo2.mp3', size: 8414 },
  { id: 'duo3', audioPath: '/audio/cmn/64k/syllabs/cmn-duo3.mp3', size: 9950 },
  { id: 'duo4', audioPath: '/audio/cmn/64k/syllabs/cmn-duo4.mp3', size: 8414 },
  { id: 'e1', audioPath: '/audio/cmn/64k/syllabs/cmn-e1.mp3', size: 8026 },
  { id: 'e2', audioPath: '/audio/cmn/64k/syllabs/cmn-e2.mp3', size: 8794 },
  { id: 'e3', audioPath: '/audio/cmn/64k/syllabs/cmn-e3.mp3', size: 10330 },
  { id: 'e4', audioPath: '/audio/cmn/64k/syllabs/cmn-e4.mp3', size: 8410 },
  { id: 'ei1', audioPath: '/audio/cmn/64k/syllabs/cmn-ei1.mp3', size: 8796 },
  { id: 'ei2', audioPath: '/audio/cmn/64k/syllabs/cmn-ei2.mp3', size: 8796 },
  { id: 'ei3', audioPath: '/audio/cmn/64k/syllabs/cmn-ei3.mp3', size: 9564 },
  { id: 'ei4', audioPath: '/audio/cmn/64k/syllabs/cmn-ei4.mp3', size: 8796 },
  { id: 'en1', audioPath: '/audio/cmn/64k/syllabs/cmn-en1.mp3', size: 9180 },
  { id: 'en2', audioPath: '/audio/cmn/64k/syllabs/cmn-en2.mp3', size: 9180 },
  { id: 'en3', audioPath: '/audio/cmn/64k/syllabs/cmn-en3.mp3', size: 9948 },
  { id: 'en4', audioPath: '/audio/cmn/64k/syllabs/cmn-en4.mp3', size: 8412 },
  { id: 'eng1', audioPath: '/audio/cmn/64k/syllabs/cmn-eng1.mp3', size: 9566 },
  { id: 'eng2', audioPath: '/audio/cmn/64k/syllabs/cmn-eng2.mp3', size: 9182 },
  { id: 'eng3', audioPath: '/audio/cmn/64k/syllabs/cmn-eng3.mp3', size: 9950 },
  { id: 'eng4', audioPath: '/audio/cmn/64k/syllabs/cmn-eng4.mp3', size: 8414 },
  { id: 'er1', audioPath: '/audio/cmn/64k/syllabs/cmn-er1.mp3', size: 8796 },
  { id: 'er2', audioPath: '/audio/cmn/64k/syllabs/cmn-er2.mp3', size: 9564 },
  { id: 'er3', audioPath: '/audio/cmn/64k/syllabs/cmn-er3.mp3', size: 10332 },
  { id: 'er4', audioPath: '/audio/cmn/64k/syllabs/cmn-er4.mp3', size: 8028 },
  { id: 'fa1', audioPath: '/audio/cmn/64k/syllabs/cmn-fa1.mp3', size: 9564 },
  { id: 'fa2', audioPath: '/audio/cmn/64k/syllabs/cmn-fa2.mp3', size: 8028 },
  { id: 'fa3', audioPath: '/audio/cmn/64k/syllabs/cmn-fa3.mp3', size: 9948 },
  { id: 'fa4', audioPath: '/audio/cmn/64k/syllabs/cmn-fa4.mp3', size: 8028 },
  { id: 'fan1', audioPath: '/audio/cmn/64k/syllabs/cmn-fan1.mp3', size: 8414 },
  { id: 'fan2', audioPath: '/audio/cmn/64k/syllabs/cmn-fan2.mp3', size: 8798 },
  { id: 'fan3', audioPath: '/audio/cmn/64k/syllabs/cmn-fan3.mp3', size: 11294 },
  { id: 'fan4', audioPath: '/audio/cmn/64k/syllabs/cmn-fan4.mp3', size: 8030 },
  {
    id: 'fang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fang1.mp3',
    size: 9952
  },
  {
    id: 'fang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fang2.mp3',
    size: 8800
  },
  {
    id: 'fang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fang3.mp3',
    size: 11296
  },
  {
    id: 'fang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fang4.mp3',
    size: 8800
  },
  { id: 'fe1', audioPath: '/audio/cmn/64k/syllabs/cmn-fe1.mp3', size: 9180 },
  { id: 'fe2', audioPath: '/audio/cmn/64k/syllabs/cmn-fe2.mp3', size: 9564 },
  { id: 'fe3', audioPath: '/audio/cmn/64k/syllabs/cmn-fe3.mp3', size: 9948 },
  { id: 'fe4', audioPath: '/audio/cmn/64k/syllabs/cmn-fe4.mp3', size: 9180 },
  { id: 'fei1', audioPath: '/audio/cmn/64k/syllabs/cmn-fei1.mp3', size: 8798 },
  { id: 'fei2', audioPath: '/audio/cmn/64k/syllabs/cmn-fei2.mp3', size: 8798 },
  { id: 'fei3', audioPath: '/audio/cmn/64k/syllabs/cmn-fei3.mp3', size: 8798 },
  { id: 'fei4', audioPath: '/audio/cmn/64k/syllabs/cmn-fei4.mp3', size: 8414 },
  { id: 'fen1', audioPath: '/audio/cmn/64k/syllabs/cmn-fen1.mp3', size: 8030 },
  { id: 'fen2', audioPath: '/audio/cmn/64k/syllabs/cmn-fen2.mp3', size: 8798 },
  { id: 'fen3', audioPath: '/audio/cmn/64k/syllabs/cmn-fen3.mp3', size: 11294 },
  { id: 'fen4', audioPath: '/audio/cmn/64k/syllabs/cmn-fen4.mp3', size: 8798 },
  {
    id: 'feng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-feng1.mp3',
    size: 10336
  },
  {
    id: 'feng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-feng2.mp3',
    size: 9568
  },
  {
    id: 'feng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-feng3.mp3',
    size: 12064
  },
  {
    id: 'feng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-feng4.mp3',
    size: 8032
  },
  {
    id: 'fiao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fiao1.mp3',
    size: 9952
  },
  {
    id: 'fiao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fiao2.mp3',
    size: 9568
  },
  {
    id: 'fiao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fiao3.mp3',
    size: 11296
  },
  {
    id: 'fiao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-fiao4.mp3',
    size: 9184
  },
  { id: 'fo1', audioPath: '/audio/cmn/64k/syllabs/cmn-fo1.mp3', size: 8412 },
  { id: 'fo2', audioPath: '/audio/cmn/64k/syllabs/cmn-fo2.mp3', size: 9180 },
  { id: 'fo3', audioPath: '/audio/cmn/64k/syllabs/cmn-fo3.mp3', size: 9564 },
  { id: 'fo4', audioPath: '/audio/cmn/64k/syllabs/cmn-fo4.mp3', size: 8796 },
  { id: 'fou1', audioPath: '/audio/cmn/64k/syllabs/cmn-fou1.mp3', size: 8798 },
  { id: 'fou2', audioPath: '/audio/cmn/64k/syllabs/cmn-fou2.mp3', size: 8798 },
  { id: 'fou3', audioPath: '/audio/cmn/64k/syllabs/cmn-fou3.mp3', size: 11294 },
  { id: 'fou4', audioPath: '/audio/cmn/64k/syllabs/cmn-fou4.mp3', size: 8030 },
  { id: 'fu1', audioPath: '/audio/cmn/64k/syllabs/cmn-fu1.mp3', size: 9180 },
  { id: 'fu2', audioPath: '/audio/cmn/64k/syllabs/cmn-fu2.mp3', size: 9180 },
  { id: 'fu3', audioPath: '/audio/cmn/64k/syllabs/cmn-fu3.mp3', size: 11676 },
  { id: 'fu4', audioPath: '/audio/cmn/64k/syllabs/cmn-fu4.mp3', size: 9180 },
  { id: 'ga1', audioPath: '/audio/cmn/64k/syllabs/cmn-ga1.mp3', size: 8796 },
  { id: 'ga2', audioPath: '/audio/cmn/64k/syllabs/cmn-ga2.mp3', size: 8412 },
  { id: 'ga3', audioPath: '/audio/cmn/64k/syllabs/cmn-ga3.mp3', size: 11292 },
  { id: 'ga4', audioPath: '/audio/cmn/64k/syllabs/cmn-ga4.mp3', size: 8412 },
  { id: 'gai1', audioPath: '/audio/cmn/64k/syllabs/cmn-gai1.mp3', size: 9182 },
  { id: 'gai2', audioPath: '/audio/cmn/64k/syllabs/cmn-gai2.mp3', size: 9566 },
  { id: 'gai3', audioPath: '/audio/cmn/64k/syllabs/cmn-gai3.mp3', size: 10334 },
  { id: 'gai4', audioPath: '/audio/cmn/64k/syllabs/cmn-gai4.mp3', size: 8414 },
  { id: 'gan1', audioPath: '/audio/cmn/64k/syllabs/cmn-gan1.mp3', size: 9566 },
  { id: 'gan2', audioPath: '/audio/cmn/64k/syllabs/cmn-gan2.mp3', size: 9950 },
  { id: 'gan3', audioPath: '/audio/cmn/64k/syllabs/cmn-gan3.mp3', size: 10718 },
  { id: 'gan4', audioPath: '/audio/cmn/64k/syllabs/cmn-gan4.mp3', size: 8414 },
  {
    id: 'gang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gang1.mp3',
    size: 8416
  },
  {
    id: 'gang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gang2.mp3',
    size: 9184
  },
  {
    id: 'gang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gang3.mp3',
    size: 9184
  },
  {
    id: 'gang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gang4.mp3',
    size: 8032
  },
  { id: 'gao1', audioPath: '/audio/cmn/64k/syllabs/cmn-gao1.mp3', size: 9182 },
  { id: 'gao2', audioPath: '/audio/cmn/64k/syllabs/cmn-gao2.mp3', size: 8414 },
  { id: 'gao3', audioPath: '/audio/cmn/64k/syllabs/cmn-gao3.mp3', size: 11294 },
  { id: 'gao4', audioPath: '/audio/cmn/64k/syllabs/cmn-gao4.mp3', size: 8414 },
  { id: 'ge1', audioPath: '/audio/cmn/64k/syllabs/cmn-ge1.mp3', size: 8796 },
  { id: 'ge2', audioPath: '/audio/cmn/64k/syllabs/cmn-ge2.mp3', size: 9564 },
  { id: 'ge3', audioPath: '/audio/cmn/64k/syllabs/cmn-ge3.mp3', size: 10332 },
  { id: 'ge4', audioPath: '/audio/cmn/64k/syllabs/cmn-ge4.mp3', size: 8412 },
  { id: 'gei1', audioPath: '/audio/cmn/64k/syllabs/cmn-gei1.mp3', size: 9182 },
  { id: 'gei2', audioPath: '/audio/cmn/64k/syllabs/cmn-gei2.mp3', size: 9182 },
  { id: 'gei3', audioPath: '/audio/cmn/64k/syllabs/cmn-gei3.mp3', size: 10718 },
  { id: 'gei4', audioPath: '/audio/cmn/64k/syllabs/cmn-gei4.mp3', size: 8414 },
  { id: 'gen1', audioPath: '/audio/cmn/64k/syllabs/cmn-gen1.mp3', size: 9182 },
  { id: 'gen2', audioPath: '/audio/cmn/64k/syllabs/cmn-gen2.mp3', size: 8798 },
  { id: 'gen3', audioPath: '/audio/cmn/64k/syllabs/cmn-gen3.mp3', size: 9950 },
  { id: 'gen4', audioPath: '/audio/cmn/64k/syllabs/cmn-gen4.mp3', size: 8030 },
  {
    id: 'geng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-geng1.mp3',
    size: 9952
  },
  {
    id: 'geng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-geng2.mp3',
    size: 9184
  },
  {
    id: 'geng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-geng3.mp3',
    size: 9952
  },
  {
    id: 'geng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-geng4.mp3',
    size: 8800
  },
  {
    id: 'gong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gong1.mp3',
    size: 8416
  },
  {
    id: 'gong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gong2.mp3',
    size: 10336
  },
  {
    id: 'gong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gong3.mp3',
    size: 10720
  },
  {
    id: 'gong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-gong4.mp3',
    size: 8800
  },
  { id: 'gou1', audioPath: '/audio/cmn/64k/syllabs/cmn-gou1.mp3', size: 8798 },
  { id: 'gou2', audioPath: '/audio/cmn/64k/syllabs/cmn-gou2.mp3', size: 9182 },
  { id: 'gou3', audioPath: '/audio/cmn/64k/syllabs/cmn-gou3.mp3', size: 10334 },
  { id: 'gou4', audioPath: '/audio/cmn/64k/syllabs/cmn-gou4.mp3', size: 8414 },
  { id: 'gu1', audioPath: '/audio/cmn/64k/syllabs/cmn-gu1.mp3', size: 9180 },
  { id: 'gu2', audioPath: '/audio/cmn/64k/syllabs/cmn-gu2.mp3', size: 8412 },
  { id: 'gu3', audioPath: '/audio/cmn/64k/syllabs/cmn-gu3.mp3', size: 10716 },
  { id: 'gu4', audioPath: '/audio/cmn/64k/syllabs/cmn-gu4.mp3', size: 8412 },
  { id: 'gua1', audioPath: '/audio/cmn/64k/syllabs/cmn-gua1.mp3', size: 9182 },
  { id: 'gua2', audioPath: '/audio/cmn/64k/syllabs/cmn-gua2.mp3', size: 9566 },
  { id: 'gua3', audioPath: '/audio/cmn/64k/syllabs/cmn-gua3.mp3', size: 10718 },
  { id: 'gua4', audioPath: '/audio/cmn/64k/syllabs/cmn-gua4.mp3', size: 8414 },
  {
    id: 'guai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guai1.mp3',
    size: 9184
  },
  {
    id: 'guai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guai2.mp3',
    size: 9568
  },
  {
    id: 'guai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guai3.mp3',
    size: 11296
  },
  {
    id: 'guai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guai4.mp3',
    size: 8032
  },
  {
    id: 'guan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guan1.mp3',
    size: 8800
  },
  {
    id: 'guan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guan2.mp3',
    size: 8032
  },
  {
    id: 'guan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guan3.mp3',
    size: 10720
  },
  {
    id: 'guan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guan4.mp3',
    size: 8032
  },
  {
    id: 'guang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guang1.mp3',
    size: 9954
  },
  {
    id: 'guang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guang2.mp3',
    size: 8802
  },
  {
    id: 'guang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guang3.mp3',
    size: 10722
  },
  {
    id: 'guang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-guang4.mp3',
    size: 8418
  },
  { id: 'gui1', audioPath: '/audio/cmn/64k/syllabs/cmn-gui1.mp3', size: 8798 },
  { id: 'gui2', audioPath: '/audio/cmn/64k/syllabs/cmn-gui2.mp3', size: 8798 },
  { id: 'gui3', audioPath: '/audio/cmn/64k/syllabs/cmn-gui3.mp3', size: 11294 },
  { id: 'gui4', audioPath: '/audio/cmn/64k/syllabs/cmn-gui4.mp3', size: 9182 },
  { id: 'gun1', audioPath: '/audio/cmn/64k/syllabs/cmn-gun1.mp3', size: 9950 },
  { id: 'gun2', audioPath: '/audio/cmn/64k/syllabs/cmn-gun2.mp3', size: 8030 },
  { id: 'gun3', audioPath: '/audio/cmn/64k/syllabs/cmn-gun3.mp3', size: 9950 },
  { id: 'gun4', audioPath: '/audio/cmn/64k/syllabs/cmn-gun4.mp3', size: 8414 },
  { id: 'guo1', audioPath: '/audio/cmn/64k/syllabs/cmn-guo1.mp3', size: 9566 },
  { id: 'guo2', audioPath: '/audio/cmn/64k/syllabs/cmn-guo2.mp3', size: 9182 },
  { id: 'guo3', audioPath: '/audio/cmn/64k/syllabs/cmn-guo3.mp3', size: 11678 },
  { id: 'guo4', audioPath: '/audio/cmn/64k/syllabs/cmn-guo4.mp3', size: 8414 },
  { id: 'ha1', audioPath: '/audio/cmn/64k/syllabs/cmn-ha1.mp3', size: 9180 },
  { id: 'ha2', audioPath: '/audio/cmn/64k/syllabs/cmn-ha2.mp3', size: 8028 },
  { id: 'ha3', audioPath: '/audio/cmn/64k/syllabs/cmn-ha3.mp3', size: 12444 },
  { id: 'ha4', audioPath: '/audio/cmn/64k/syllabs/cmn-ha4.mp3', size: 8028 },
  { id: 'hai1', audioPath: '/audio/cmn/64k/syllabs/cmn-hai1.mp3', size: 9950 },
  { id: 'hai2', audioPath: '/audio/cmn/64k/syllabs/cmn-hai2.mp3', size: 9182 },
  { id: 'hai3', audioPath: '/audio/cmn/64k/syllabs/cmn-hai3.mp3', size: 11678 },
  { id: 'hai4', audioPath: '/audio/cmn/64k/syllabs/cmn-hai4.mp3', size: 8030 },
  { id: 'han1', audioPath: '/audio/cmn/64k/syllabs/cmn-han1.mp3', size: 9182 },
  { id: 'han2', audioPath: '/audio/cmn/64k/syllabs/cmn-han2.mp3', size: 9182 },
  { id: 'han3', audioPath: '/audio/cmn/64k/syllabs/cmn-han3.mp3', size: 9566 },
  { id: 'han4', audioPath: '/audio/cmn/64k/syllabs/cmn-han4.mp3', size: 8414 },
  {
    id: 'hang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hang1.mp3',
    size: 9184
  },
  {
    id: 'hang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hang2.mp3',
    size: 9568
  },
  {
    id: 'hang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hang3.mp3',
    size: 11680
  },
  {
    id: 'hang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hang4.mp3',
    size: 8416
  },
  { id: 'hao1', audioPath: '/audio/cmn/64k/syllabs/cmn-hao1.mp3', size: 8798 },
  { id: 'hao2', audioPath: '/audio/cmn/64k/syllabs/cmn-hao2.mp3', size: 8414 },
  { id: 'hao3', audioPath: '/audio/cmn/64k/syllabs/cmn-hao3.mp3', size: 11294 },
  { id: 'hao4', audioPath: '/audio/cmn/64k/syllabs/cmn-hao4.mp3', size: 8414 },
  { id: 'he1', audioPath: '/audio/cmn/64k/syllabs/cmn-he1.mp3', size: 10332 },
  { id: 'he2', audioPath: '/audio/cmn/64k/syllabs/cmn-he2.mp3', size: 9564 },
  { id: 'he3', audioPath: '/audio/cmn/64k/syllabs/cmn-he3.mp3', size: 11292 },
  { id: 'he4', audioPath: '/audio/cmn/64k/syllabs/cmn-he4.mp3', size: 9180 },
  { id: 'hei1', audioPath: '/audio/cmn/64k/syllabs/cmn-hei1.mp3', size: 8798 },
  { id: 'hei2', audioPath: '/audio/cmn/64k/syllabs/cmn-hei2.mp3', size: 8798 },
  { id: 'hei3', audioPath: '/audio/cmn/64k/syllabs/cmn-hei3.mp3', size: 8798 },
  { id: 'hei4', audioPath: '/audio/cmn/64k/syllabs/cmn-hei4.mp3', size: 8798 },
  { id: 'hen1', audioPath: '/audio/cmn/64k/syllabs/cmn-hen1.mp3', size: 9566 },
  { id: 'hen2', audioPath: '/audio/cmn/64k/syllabs/cmn-hen2.mp3', size: 8798 },
  { id: 'hen3', audioPath: '/audio/cmn/64k/syllabs/cmn-hen3.mp3', size: 9950 },
  { id: 'hen4', audioPath: '/audio/cmn/64k/syllabs/cmn-hen4.mp3', size: 8798 },
  {
    id: 'heng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-heng1.mp3',
    size: 9184
  },
  {
    id: 'heng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-heng2.mp3',
    size: 8416
  },
  {
    id: 'heng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-heng3.mp3',
    size: 9952
  },
  {
    id: 'heng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-heng4.mp3',
    size: 8416
  },
  {
    id: 'hong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hong1.mp3',
    size: 8416
  },
  {
    id: 'hong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hong2.mp3',
    size: 9568
  },
  {
    id: 'hong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hong3.mp3',
    size: 11296
  },
  {
    id: 'hong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-hong4.mp3',
    size: 8800
  },
  { id: 'hou1', audioPath: '/audio/cmn/64k/syllabs/cmn-hou1.mp3', size: 9182 },
  { id: 'hou2', audioPath: '/audio/cmn/64k/syllabs/cmn-hou2.mp3', size: 9182 },
  { id: 'hou3', audioPath: '/audio/cmn/64k/syllabs/cmn-hou3.mp3', size: 11294 },
  { id: 'hou4', audioPath: '/audio/cmn/64k/syllabs/cmn-hou4.mp3', size: 8798 },
  { id: 'hu1', audioPath: '/audio/cmn/64k/syllabs/cmn-hu1.mp3', size: 9180 },
  { id: 'hu2', audioPath: '/audio/cmn/64k/syllabs/cmn-hu2.mp3', size: 8412 },
  { id: 'hu3', audioPath: '/audio/cmn/64k/syllabs/cmn-hu3.mp3', size: 10716 },
  { id: 'hu4', audioPath: '/audio/cmn/64k/syllabs/cmn-hu4.mp3', size: 8796 },
  { id: 'hua1', audioPath: '/audio/cmn/64k/syllabs/cmn-hua1.mp3', size: 9950 },
  { id: 'hua2', audioPath: '/audio/cmn/64k/syllabs/cmn-hua2.mp3', size: 9566 },
  { id: 'hua3', audioPath: '/audio/cmn/64k/syllabs/cmn-hua3.mp3', size: 12446 },
  { id: 'hua4', audioPath: '/audio/cmn/64k/syllabs/cmn-hua4.mp3', size: 8414 },
  {
    id: 'huai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huai1.mp3',
    size: 8800
  },
  {
    id: 'huai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huai2.mp3',
    size: 8800
  },
  {
    id: 'huai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huai3.mp3',
    size: 9952
  },
  {
    id: 'huai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huai4.mp3',
    size: 9184
  },
  {
    id: 'huan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huan1.mp3',
    size: 9568
  },
  {
    id: 'huan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huan2.mp3',
    size: 10336
  },
  {
    id: 'huan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huan3.mp3',
    size: 11680
  },
  {
    id: 'huan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huan4.mp3',
    size: 8416
  },
  {
    id: 'huang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huang1.mp3',
    size: 10338
  },
  {
    id: 'huang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huang2.mp3',
    size: 9954
  },
  {
    id: 'huang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huang3.mp3',
    size: 12834
  },
  {
    id: 'huang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-huang4.mp3',
    size: 9186
  },
  { id: 'hui1', audioPath: '/audio/cmn/64k/syllabs/cmn-hui1.mp3', size: 9566 },
  { id: 'hui2', audioPath: '/audio/cmn/64k/syllabs/cmn-hui2.mp3', size: 9182 },
  { id: 'hui3', audioPath: '/audio/cmn/64k/syllabs/cmn-hui3.mp3', size: 12062 },
  { id: 'hui4', audioPath: '/audio/cmn/64k/syllabs/cmn-hui4.mp3', size: 8798 },
  { id: 'hun1', audioPath: '/audio/cmn/64k/syllabs/cmn-hun1.mp3', size: 12446 },
  { id: 'hun2', audioPath: '/audio/cmn/64k/syllabs/cmn-hun2.mp3', size: 9566 },
  { id: 'hun3', audioPath: '/audio/cmn/64k/syllabs/cmn-hun3.mp3', size: 11294 },
  { id: 'hun4', audioPath: '/audio/cmn/64k/syllabs/cmn-hun4.mp3', size: 9566 },
  { id: 'huo1', audioPath: '/audio/cmn/64k/syllabs/cmn-huo1.mp3', size: 8414 },
  { id: 'huo2', audioPath: '/audio/cmn/64k/syllabs/cmn-huo2.mp3', size: 8414 },
  { id: 'huo3', audioPath: '/audio/cmn/64k/syllabs/cmn-huo3.mp3', size: 12062 },
  { id: 'huo4', audioPath: '/audio/cmn/64k/syllabs/cmn-huo4.mp3', size: 9182 },
  { id: 'ji1', audioPath: '/audio/cmn/64k/syllabs/cmn-ji1.mp3', size: 9180 },
  { id: 'ji2', audioPath: '/audio/cmn/64k/syllabs/cmn-ji2.mp3', size: 9564 },
  { id: 'ji3', audioPath: '/audio/cmn/64k/syllabs/cmn-ji3.mp3', size: 12444 },
  { id: 'ji4', audioPath: '/audio/cmn/64k/syllabs/cmn-ji4.mp3', size: 8796 },
  { id: 'jia1', audioPath: '/audio/cmn/64k/syllabs/cmn-jia1.mp3', size: 9950 },
  { id: 'jia2', audioPath: '/audio/cmn/64k/syllabs/cmn-jia2.mp3', size: 8414 },
  { id: 'jia3', audioPath: '/audio/cmn/64k/syllabs/cmn-jia3.mp3', size: 12446 },
  { id: 'jia4', audioPath: '/audio/cmn/64k/syllabs/cmn-jia4.mp3', size: 9566 },
  {
    id: 'jian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jian1.mp3',
    size: 9952
  },
  {
    id: 'jian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jian2.mp3',
    size: 9568
  },
  {
    id: 'jian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jian3.mp3',
    size: 11296
  },
  {
    id: 'jian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jian4.mp3',
    size: 9568
  },
  {
    id: 'jiang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiang1.mp3',
    size: 10338
  },
  {
    id: 'jiang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiang2.mp3',
    size: 9186
  },
  {
    id: 'jiang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiang3.mp3',
    size: 11682
  },
  {
    id: 'jiang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiang4.mp3',
    size: 8418
  },
  {
    id: 'jiao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiao1.mp3',
    size: 8416
  },
  {
    id: 'jiao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiao2.mp3',
    size: 8416
  },
  {
    id: 'jiao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiao3.mp3',
    size: 12448
  },
  {
    id: 'jiao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiao4.mp3',
    size: 9568
  },
  { id: 'jie1', audioPath: '/audio/cmn/64k/syllabs/cmn-jie1.mp3', size: 9566 },
  { id: 'jie2', audioPath: '/audio/cmn/64k/syllabs/cmn-jie2.mp3', size: 9566 },
  { id: 'jie3', audioPath: '/audio/cmn/64k/syllabs/cmn-jie3.mp3', size: 11678 },
  { id: 'jie4', audioPath: '/audio/cmn/64k/syllabs/cmn-jie4.mp3', size: 8030 },
  { id: 'jin1', audioPath: '/audio/cmn/64k/syllabs/cmn-jin1.mp3', size: 8798 },
  { id: 'jin2', audioPath: '/audio/cmn/64k/syllabs/cmn-jin2.mp3', size: 9182 },
  { id: 'jin3', audioPath: '/audio/cmn/64k/syllabs/cmn-jin3.mp3', size: 11294 },
  { id: 'jin4', audioPath: '/audio/cmn/64k/syllabs/cmn-jin4.mp3', size: 8798 },
  {
    id: 'jing1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jing1.mp3',
    size: 9952
  },
  {
    id: 'jing2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jing2.mp3',
    size: 9184
  },
  {
    id: 'jing3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jing3.mp3',
    size: 10336
  },
  {
    id: 'jing4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jing4.mp3',
    size: 8800
  },
  {
    id: 'jiong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiong1.mp3',
    size: 10338
  },
  {
    id: 'jiong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiong2.mp3',
    size: 8802
  },
  {
    id: 'jiong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiong3.mp3',
    size: 12066
  },
  {
    id: 'jiong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-jiong4.mp3',
    size: 9186
  },
  { id: 'jiu1', audioPath: '/audio/cmn/64k/syllabs/cmn-jiu1.mp3', size: 9566 },
  { id: 'jiu2', audioPath: '/audio/cmn/64k/syllabs/cmn-jiu2.mp3', size: 9182 },
  { id: 'jiu3', audioPath: '/audio/cmn/64k/syllabs/cmn-jiu3.mp3', size: 11294 },
  { id: 'jiu4', audioPath: '/audio/cmn/64k/syllabs/cmn-jiu4.mp3', size: 9182 },
  { id: 'ju1', audioPath: '/audio/cmn/64k/syllabs/cmn-ju1.mp3', size: 9180 },
  { id: 'ju2', audioPath: '/audio/cmn/64k/syllabs/cmn-ju2.mp3', size: 8028 },
  { id: 'ju3', audioPath: '/audio/cmn/64k/syllabs/cmn-ju3.mp3', size: 12828 },
  {
    id: 'juan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-juan1.mp3',
    size: 9184
  },
  {
    id: 'juan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-juan2.mp3',
    size: 9184
  },
  {
    id: 'juan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-juan3.mp3',
    size: 12832
  },
  {
    id: 'juan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-juan4.mp3',
    size: 9568
  },
  { id: 'jue1', audioPath: '/audio/cmn/64k/syllabs/cmn-jue1.mp3', size: 8798 },
  { id: 'jue2', audioPath: '/audio/cmn/64k/syllabs/cmn-jue2.mp3', size: 8414 },
  { id: 'jue3', audioPath: '/audio/cmn/64k/syllabs/cmn-jue3.mp3', size: 12446 },
  { id: 'jue4', audioPath: '/audio/cmn/64k/syllabs/cmn-jue4.mp3', size: 8030 },
  { id: 'jun1', audioPath: '/audio/cmn/64k/syllabs/cmn-jun1.mp3', size: 9182 },
  { id: 'jun2', audioPath: '/audio/cmn/64k/syllabs/cmn-jun2.mp3', size: 9950 },
  { id: 'jun3', audioPath: '/audio/cmn/64k/syllabs/cmn-jun3.mp3', size: 11294 },
  { id: 'jun4', audioPath: '/audio/cmn/64k/syllabs/cmn-jun4.mp3', size: 9566 },
  { id: 'jv4', audioPath: '/audio/cmn/64k/syllabs/cmn-jv4.mp3', size: 9180 },
  { id: 'ka1', audioPath: '/audio/cmn/64k/syllabs/cmn-ka1.mp3', size: 8412 },
  { id: 'ka2', audioPath: '/audio/cmn/64k/syllabs/cmn-ka2.mp3', size: 9180 },
  { id: 'ka3', audioPath: '/audio/cmn/64k/syllabs/cmn-ka3.mp3', size: 9948 },
  { id: 'ka4', audioPath: '/audio/cmn/64k/syllabs/cmn-ka4.mp3', size: 8796 },
  { id: 'kai1', audioPath: '/audio/cmn/64k/syllabs/cmn-kai1.mp3', size: 8798 },
  { id: 'kai2', audioPath: '/audio/cmn/64k/syllabs/cmn-kai2.mp3', size: 8798 },
  { id: 'kai3', audioPath: '/audio/cmn/64k/syllabs/cmn-kai3.mp3', size: 12830 },
  { id: 'kai4', audioPath: '/audio/cmn/64k/syllabs/cmn-kai4.mp3', size: 8798 },
  { id: 'kan1', audioPath: '/audio/cmn/64k/syllabs/cmn-kan1.mp3', size: 8030 },
  { id: 'kan2', audioPath: '/audio/cmn/64k/syllabs/cmn-kan2.mp3', size: 9566 },
  { id: 'kan3', audioPath: '/audio/cmn/64k/syllabs/cmn-kan3.mp3', size: 11294 },
  { id: 'kan4', audioPath: '/audio/cmn/64k/syllabs/cmn-kan4.mp3', size: 9566 },
  {
    id: 'kang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kang1.mp3',
    size: 8416
  },
  {
    id: 'kang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kang2.mp3',
    size: 9568
  },
  {
    id: 'kang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kang3.mp3',
    size: 12448
  },
  {
    id: 'kang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kang4.mp3',
    size: 8032
  },
  { id: 'kao1', audioPath: '/audio/cmn/64k/syllabs/cmn-kao1.mp3', size: 8030 },
  { id: 'kao2', audioPath: '/audio/cmn/64k/syllabs/cmn-kao2.mp3', size: 9182 },
  { id: 'kao3', audioPath: '/audio/cmn/64k/syllabs/cmn-kao3.mp3', size: 11678 },
  { id: 'kao4', audioPath: '/audio/cmn/64k/syllabs/cmn-kao4.mp3', size: 8798 },
  { id: 'ke1', audioPath: '/audio/cmn/64k/syllabs/cmn-ke1.mp3', size: 9564 },
  { id: 'ke2', audioPath: '/audio/cmn/64k/syllabs/cmn-ke2.mp3', size: 9564 },
  { id: 'ke3', audioPath: '/audio/cmn/64k/syllabs/cmn-ke3.mp3', size: 11676 },
  { id: 'ke4', audioPath: '/audio/cmn/64k/syllabs/cmn-ke4.mp3', size: 8796 },
  { id: 'kei1', audioPath: '/audio/cmn/64k/syllabs/cmn-kei1.mp3', size: 9566 },
  { id: 'kei2', audioPath: '/audio/cmn/64k/syllabs/cmn-kei2.mp3', size: 9566 },
  { id: 'kei3', audioPath: '/audio/cmn/64k/syllabs/cmn-kei3.mp3', size: 9566 },
  { id: 'kei4', audioPath: '/audio/cmn/64k/syllabs/cmn-kei4.mp3', size: 8414 },
  { id: 'ken1', audioPath: '/audio/cmn/64k/syllabs/cmn-ken1.mp3', size: 8414 },
  { id: 'ken2', audioPath: '/audio/cmn/64k/syllabs/cmn-ken2.mp3', size: 9566 },
  { id: 'ken3', audioPath: '/audio/cmn/64k/syllabs/cmn-ken3.mp3', size: 11678 },
  { id: 'ken4', audioPath: '/audio/cmn/64k/syllabs/cmn-ken4.mp3', size: 9182 },
  {
    id: 'keng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-keng1.mp3',
    size: 9952
  },
  {
    id: 'keng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-keng2.mp3',
    size: 9184
  },
  {
    id: 'keng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-keng3.mp3',
    size: 11680
  },
  {
    id: 'keng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-keng4.mp3',
    size: 8416
  },
  {
    id: 'kong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kong1.mp3',
    size: 9184
  },
  {
    id: 'kong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kong2.mp3',
    size: 9952
  },
  {
    id: 'kong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kong3.mp3',
    size: 11296
  },
  {
    id: 'kong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kong4.mp3',
    size: 9184
  },
  { id: 'kou1', audioPath: '/audio/cmn/64k/syllabs/cmn-kou1.mp3', size: 9566 },
  { id: 'kou2', audioPath: '/audio/cmn/64k/syllabs/cmn-kou2.mp3', size: 8414 },
  { id: 'kou3', audioPath: '/audio/cmn/64k/syllabs/cmn-kou3.mp3', size: 10334 },
  { id: 'kou4', audioPath: '/audio/cmn/64k/syllabs/cmn-kou4.mp3', size: 8414 },
  { id: 'ku1', audioPath: '/audio/cmn/64k/syllabs/cmn-ku1.mp3', size: 8796 },
  { id: 'ku2', audioPath: '/audio/cmn/64k/syllabs/cmn-ku2.mp3', size: 9180 },
  { id: 'ku3', audioPath: '/audio/cmn/64k/syllabs/cmn-ku3.mp3', size: 11292 },
  { id: 'ku4', audioPath: '/audio/cmn/64k/syllabs/cmn-ku4.mp3', size: 8796 },
  { id: 'kua1', audioPath: '/audio/cmn/64k/syllabs/cmn-kua1.mp3', size: 10334 },
  { id: 'kua2', audioPath: '/audio/cmn/64k/syllabs/cmn-kua2.mp3', size: 9182 },
  { id: 'kua3', audioPath: '/audio/cmn/64k/syllabs/cmn-kua3.mp3', size: 11678 },
  { id: 'kua4', audioPath: '/audio/cmn/64k/syllabs/cmn-kua4.mp3', size: 8414 },
  {
    id: 'kuai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuai1.mp3',
    size: 9568
  },
  {
    id: 'kuai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuai2.mp3',
    size: 8800
  },
  {
    id: 'kuai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuai3.mp3',
    size: 10336
  },
  {
    id: 'kuai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuai4.mp3',
    size: 8416
  },
  {
    id: 'kuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuan1.mp3',
    size: 9952
  },
  {
    id: 'kuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuan2.mp3',
    size: 9568
  },
  {
    id: 'kuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuan3.mp3',
    size: 11680
  },
  {
    id: 'kuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuan4.mp3',
    size: 9952
  },
  {
    id: 'kuang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuang1.mp3',
    size: 8418
  },
  {
    id: 'kuang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuang2.mp3',
    size: 10338
  },
  {
    id: 'kuang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuang3.mp3',
    size: 9954
  },
  {
    id: 'kuang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-kuang4.mp3',
    size: 8034
  },
  { id: 'kui1', audioPath: '/audio/cmn/64k/syllabs/cmn-kui1.mp3', size: 9566 },
  { id: 'kui2', audioPath: '/audio/cmn/64k/syllabs/cmn-kui2.mp3', size: 9566 },
  { id: 'kui3', audioPath: '/audio/cmn/64k/syllabs/cmn-kui3.mp3', size: 11294 },
  { id: 'kui4', audioPath: '/audio/cmn/64k/syllabs/cmn-kui4.mp3', size: 8030 },
  { id: 'kun1', audioPath: '/audio/cmn/64k/syllabs/cmn-kun1.mp3', size: 9950 },
  { id: 'kun2', audioPath: '/audio/cmn/64k/syllabs/cmn-kun2.mp3', size: 9950 },
  { id: 'kun3', audioPath: '/audio/cmn/64k/syllabs/cmn-kun3.mp3', size: 11294 },
  { id: 'kun4', audioPath: '/audio/cmn/64k/syllabs/cmn-kun4.mp3', size: 9182 },
  { id: 'kuo1', audioPath: '/audio/cmn/64k/syllabs/cmn-kuo1.mp3', size: 9566 },
  { id: 'kuo2', audioPath: '/audio/cmn/64k/syllabs/cmn-kuo2.mp3', size: 8414 },
  { id: 'kuo3', audioPath: '/audio/cmn/64k/syllabs/cmn-kuo3.mp3', size: 11678 },
  { id: 'kuo4', audioPath: '/audio/cmn/64k/syllabs/cmn-kuo4.mp3', size: 8030 },
  { id: 'la1', audioPath: '/audio/cmn/64k/syllabs/cmn-la1.mp3', size: 9180 },
  { id: 'la2', audioPath: '/audio/cmn/64k/syllabs/cmn-la2.mp3', size: 9564 },
  { id: 'la3', audioPath: '/audio/cmn/64k/syllabs/cmn-la3.mp3', size: 11676 },
  { id: 'la4', audioPath: '/audio/cmn/64k/syllabs/cmn-la4.mp3', size: 8796 },
  { id: 'lai1', audioPath: '/audio/cmn/64k/syllabs/cmn-lai1.mp3', size: 8798 },
  { id: 'lai2', audioPath: '/audio/cmn/64k/syllabs/cmn-lai2.mp3', size: 9950 },
  { id: 'lai3', audioPath: '/audio/cmn/64k/syllabs/cmn-lai3.mp3', size: 10718 },
  { id: 'lai4', audioPath: '/audio/cmn/64k/syllabs/cmn-lai4.mp3', size: 8798 },
  { id: 'lan1', audioPath: '/audio/cmn/64k/syllabs/cmn-lan1.mp3', size: 9950 },
  { id: 'lan2', audioPath: '/audio/cmn/64k/syllabs/cmn-lan2.mp3', size: 9950 },
  { id: 'lan3', audioPath: '/audio/cmn/64k/syllabs/cmn-lan3.mp3', size: 9182 },
  { id: 'lan4', audioPath: '/audio/cmn/64k/syllabs/cmn-lan4.mp3', size: 9566 },
  {
    id: 'lang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lang1.mp3',
    size: 9184
  },
  {
    id: 'lang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lang2.mp3',
    size: 9184
  },
  {
    id: 'lang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lang3.mp3',
    size: 11296
  },
  {
    id: 'lang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lang4.mp3',
    size: 8416
  },
  { id: 'lao1', audioPath: '/audio/cmn/64k/syllabs/cmn-lao1.mp3', size: 9566 },
  { id: 'lao2', audioPath: '/audio/cmn/64k/syllabs/cmn-lao2.mp3', size: 9566 },
  { id: 'lao3', audioPath: '/audio/cmn/64k/syllabs/cmn-lao3.mp3', size: 11294 },
  { id: 'lao4', audioPath: '/audio/cmn/64k/syllabs/cmn-lao4.mp3', size: 9182 },
  { id: 'le1', audioPath: '/audio/cmn/64k/syllabs/cmn-le1.mp3', size: 8796 },
  { id: 'le2', audioPath: '/audio/cmn/64k/syllabs/cmn-le2.mp3', size: 8796 },
  { id: 'le3', audioPath: '/audio/cmn/64k/syllabs/cmn-le3.mp3', size: 10716 },
  { id: 'le4', audioPath: '/audio/cmn/64k/syllabs/cmn-le4.mp3', size: 8796 },
  { id: 'lei1', audioPath: '/audio/cmn/64k/syllabs/cmn-lei1.mp3', size: 8414 },
  { id: 'lei2', audioPath: '/audio/cmn/64k/syllabs/cmn-lei2.mp3', size: 9950 },
  { id: 'lei3', audioPath: '/audio/cmn/64k/syllabs/cmn-lei3.mp3', size: 12062 },
  { id: 'lei4', audioPath: '/audio/cmn/64k/syllabs/cmn-lei4.mp3', size: 9182 },
  {
    id: 'leng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-leng1.mp3',
    size: 9568
  },
  {
    id: 'leng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-leng2.mp3',
    size: 8800
  },
  {
    id: 'leng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-leng3.mp3',
    size: 12064
  },
  {
    id: 'leng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-leng4.mp3',
    size: 8800
  },
  { id: 'li1', audioPath: '/audio/cmn/64k/syllabs/cmn-li1.mp3', size: 8796 },
  { id: 'li2', audioPath: '/audio/cmn/64k/syllabs/cmn-li2.mp3', size: 8796 },
  { id: 'li3', audioPath: '/audio/cmn/64k/syllabs/cmn-li3.mp3', size: 10332 },
  { id: 'li4', audioPath: '/audio/cmn/64k/syllabs/cmn-li4.mp3', size: 9180 },
  { id: 'lia1', audioPath: '/audio/cmn/64k/syllabs/cmn-lia1.mp3', size: 8798 },
  { id: 'lia2', audioPath: '/audio/cmn/64k/syllabs/cmn-lia2.mp3', size: 9182 },
  { id: 'lia3', audioPath: '/audio/cmn/64k/syllabs/cmn-lia3.mp3', size: 12446 },
  { id: 'lia4', audioPath: '/audio/cmn/64k/syllabs/cmn-lia4.mp3', size: 9566 },
  {
    id: 'lian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lian1.mp3',
    size: 9568
  },
  {
    id: 'lian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lian2.mp3',
    size: 10336
  },
  {
    id: 'lian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lian3.mp3',
    size: 12448
  },
  {
    id: 'lian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-lian4.mp3',
    size: 8032
  },
  {
    id: 'liang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liang1.mp3',
    size: 9954
  },
  {
    id: 'liang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liang2.mp3',
    size: 9954
  },
  {
    id: 'liang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liang3.mp3',
    size: 11298
  },
  {
    id: 'liang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liang4.mp3',
    size: 8802
  },
  {
    id: 'liao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liao1.mp3',
    size: 9184
  },
  {
    id: 'liao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liao2.mp3',
    size: 9184
  },
  {
    id: 'liao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liao3.mp3',
    size: 12448
  },
  {
    id: 'liao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-liao4.mp3',
    size: 8416
  },
  { id: 'lie1', audioPath: '/audio/cmn/64k/syllabs/cmn-lie1.mp3', size: 8030 },
  { id: 'lie2', audioPath: '/audio/cmn/64k/syllabs/cmn-lie2.mp3', size: 9182 },
  { id: 'lie3', audioPath: '/audio/cmn/64k/syllabs/cmn-lie3.mp3', size: 11294 },
  { id: 'lie4', audioPath: '/audio/cmn/64k/syllabs/cmn-lie4.mp3', size: 9182 },
  { id: 'lin1', audioPath: '/audio/cmn/64k/syllabs/cmn-lin1.mp3', size: 9566 },
  { id: 'lin2', audioPath: '/audio/cmn/64k/syllabs/cmn-lin2.mp3', size: 9950 },
  { id: 'lin3', audioPath: '/audio/cmn/64k/syllabs/cmn-lin3.mp3', size: 12062 },
  { id: 'lin4', audioPath: '/audio/cmn/64k/syllabs/cmn-lin4.mp3', size: 9566 },
  {
    id: 'ling1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ling1.mp3',
    size: 10336
  },
  {
    id: 'ling2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ling2.mp3',
    size: 10336
  },
  {
    id: 'ling3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ling3.mp3',
    size: 11680
  },
  {
    id: 'ling4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ling4.mp3',
    size: 8416
  },
  { id: 'liu1', audioPath: '/audio/cmn/64k/syllabs/cmn-liu1.mp3', size: 9182 },
  { id: 'liu2', audioPath: '/audio/cmn/64k/syllabs/cmn-liu2.mp3', size: 8414 },
  { id: 'liu3', audioPath: '/audio/cmn/64k/syllabs/cmn-liu3.mp3', size: 12446 },
  { id: 'liu4', audioPath: '/audio/cmn/64k/syllabs/cmn-liu4.mp3', size: 9182 },
  { id: 'lo1', audioPath: '/audio/cmn/64k/syllabs/cmn-lo1.mp3', size: 9180 },
  { id: 'lo2', audioPath: '/audio/cmn/64k/syllabs/cmn-lo2.mp3', size: 9564 },
  { id: 'lo3', audioPath: '/audio/cmn/64k/syllabs/cmn-lo3.mp3', size: 12060 },
  { id: 'lo4', audioPath: '/audio/cmn/64k/syllabs/cmn-lo4.mp3', size: 9180 },
  {
    id: 'long1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-long1.mp3',
    size: 9184
  },
  {
    id: 'long2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-long2.mp3',
    size: 8800
  },
  {
    id: 'long3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-long3.mp3',
    size: 11680
  },
  {
    id: 'long4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-long4.mp3',
    size: 8800
  },
  { id: 'lou1', audioPath: '/audio/cmn/64k/syllabs/cmn-lou1.mp3', size: 9566 },
  { id: 'lou2', audioPath: '/audio/cmn/64k/syllabs/cmn-lou2.mp3', size: 10334 },
  { id: 'lou3', audioPath: '/audio/cmn/64k/syllabs/cmn-lou3.mp3', size: 11678 },
  { id: 'lou4', audioPath: '/audio/cmn/64k/syllabs/cmn-lou4.mp3', size: 9566 },
  { id: 'lu1', audioPath: '/audio/cmn/64k/syllabs/cmn-lu1.mp3', size: 8796 },
  { id: 'lu2', audioPath: '/audio/cmn/64k/syllabs/cmn-lu2.mp3', size: 9564 },
  { id: 'lu3', audioPath: '/audio/cmn/64k/syllabs/cmn-lu3.mp3', size: 10716 },
  { id: 'lu4', audioPath: '/audio/cmn/64k/syllabs/cmn-lu4.mp3', size: 8796 },
  {
    id: 'luan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-luan1.mp3',
    size: 9568
  },
  {
    id: 'luan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-luan2.mp3',
    size: 10720
  },
  {
    id: 'luan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-luan3.mp3',
    size: 12448
  },
  {
    id: 'luan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-luan4.mp3',
    size: 8800
  },
  { id: 'lun1', audioPath: '/audio/cmn/64k/syllabs/cmn-lun1.mp3', size: 9182 },
  { id: 'lun2', audioPath: '/audio/cmn/64k/syllabs/cmn-lun2.mp3', size: 8798 },
  { id: 'lun3', audioPath: '/audio/cmn/64k/syllabs/cmn-lun3.mp3', size: 12446 },
  { id: 'lun4', audioPath: '/audio/cmn/64k/syllabs/cmn-lun4.mp3', size: 9566 },
  { id: 'luo1', audioPath: '/audio/cmn/64k/syllabs/cmn-luo1.mp3', size: 9182 },
  { id: 'luo2', audioPath: '/audio/cmn/64k/syllabs/cmn-luo2.mp3', size: 9950 },
  { id: 'luo3', audioPath: '/audio/cmn/64k/syllabs/cmn-luo3.mp3', size: 10718 },
  { id: 'luo4', audioPath: '/audio/cmn/64k/syllabs/cmn-luo4.mp3', size: 8414 },
  { id: 'lv1', audioPath: '/audio/cmn/64k/syllabs/cmn-lv1.mp3', size: 9180 },
  { id: 'lv2', audioPath: '/audio/cmn/64k/syllabs/cmn-lv2.mp3', size: 9948 },
  { id: 'lv3', audioPath: '/audio/cmn/64k/syllabs/cmn-lv3.mp3', size: 12060 },
  { id: 'lv4', audioPath: '/audio/cmn/64k/syllabs/cmn-lv4.mp3', size: 8796 },
  { id: 'lve1', audioPath: '/audio/cmn/64k/syllabs/cmn-lve1.mp3', size: 8414 },
  { id: 'lve2', audioPath: '/audio/cmn/64k/syllabs/cmn-lve2.mp3', size: 8030 },
  { id: 'lve3', audioPath: '/audio/cmn/64k/syllabs/cmn-lve3.mp3', size: 11678 },
  { id: 'lve4', audioPath: '/audio/cmn/64k/syllabs/cmn-lve4.mp3', size: 8798 },
  { id: 'ma1', audioPath: '/audio/cmn/64k/syllabs/cmn-ma1.mp3', size: 9180 },
  { id: 'ma2', audioPath: '/audio/cmn/64k/syllabs/cmn-ma2.mp3', size: 8796 },
  { id: 'ma3', audioPath: '/audio/cmn/64k/syllabs/cmn-ma3.mp3', size: 12060 },
  { id: 'ma4', audioPath: '/audio/cmn/64k/syllabs/cmn-ma4.mp3', size: 8412 },
  { id: 'mai1', audioPath: '/audio/cmn/64k/syllabs/cmn-mai1.mp3', size: 9182 },
  { id: 'mai2', audioPath: '/audio/cmn/64k/syllabs/cmn-mai2.mp3', size: 9950 },
  { id: 'mai3', audioPath: '/audio/cmn/64k/syllabs/cmn-mai3.mp3', size: 11678 },
  { id: 'mai4', audioPath: '/audio/cmn/64k/syllabs/cmn-mai4.mp3', size: 8030 },
  { id: 'man1', audioPath: '/audio/cmn/64k/syllabs/cmn-man1.mp3', size: 9566 },
  { id: 'man2', audioPath: '/audio/cmn/64k/syllabs/cmn-man2.mp3', size: 9566 },
  { id: 'man3', audioPath: '/audio/cmn/64k/syllabs/cmn-man3.mp3', size: 11294 },
  { id: 'man4', audioPath: '/audio/cmn/64k/syllabs/cmn-man4.mp3', size: 9182 },
  {
    id: 'mang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mang1.mp3',
    size: 9184
  },
  {
    id: 'mang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mang2.mp3',
    size: 9184
  },
  {
    id: 'mang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mang3.mp3',
    size: 12832
  },
  {
    id: 'mang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mang4.mp3',
    size: 8800
  },
  { id: 'mao1', audioPath: '/audio/cmn/64k/syllabs/cmn-mao1.mp3', size: 9566 },
  { id: 'mao2', audioPath: '/audio/cmn/64k/syllabs/cmn-mao2.mp3', size: 8030 },
  { id: 'mao3', audioPath: '/audio/cmn/64k/syllabs/cmn-mao3.mp3', size: 11678 },
  { id: 'mao4', audioPath: '/audio/cmn/64k/syllabs/cmn-mao4.mp3', size: 9566 },
  { id: 'me1', audioPath: '/audio/cmn/64k/syllabs/cmn-me1.mp3', size: 8796 },
  { id: 'me2', audioPath: '/audio/cmn/64k/syllabs/cmn-me2.mp3', size: 9180 },
  { id: 'me3', audioPath: '/audio/cmn/64k/syllabs/cmn-me3.mp3', size: 10332 },
  { id: 'me4', audioPath: '/audio/cmn/64k/syllabs/cmn-me4.mp3', size: 9180 },
  { id: 'mei1', audioPath: '/audio/cmn/64k/syllabs/cmn-mei1.mp3', size: 9950 },
  { id: 'mei2', audioPath: '/audio/cmn/64k/syllabs/cmn-mei2.mp3', size: 9566 },
  { id: 'mei3', audioPath: '/audio/cmn/64k/syllabs/cmn-mei3.mp3', size: 11294 },
  { id: 'mei4', audioPath: '/audio/cmn/64k/syllabs/cmn-mei4.mp3', size: 9182 },
  { id: 'men1', audioPath: '/audio/cmn/64k/syllabs/cmn-men1.mp3', size: 9182 },
  { id: 'men2', audioPath: '/audio/cmn/64k/syllabs/cmn-men2.mp3', size: 9566 },
  { id: 'men3', audioPath: '/audio/cmn/64k/syllabs/cmn-men3.mp3', size: 11294 },
  { id: 'men4', audioPath: '/audio/cmn/64k/syllabs/cmn-men4.mp3', size: 8030 },
  {
    id: 'meng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-meng1.mp3',
    size: 8032
  },
  {
    id: 'meng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-meng2.mp3',
    size: 9568
  },
  {
    id: 'meng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-meng3.mp3',
    size: 11296
  },
  {
    id: 'meng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-meng4.mp3',
    size: 8800
  },
  { id: 'mi1', audioPath: '/audio/cmn/64k/syllabs/cmn-mi1.mp3', size: 9180 },
  { id: 'mi2', audioPath: '/audio/cmn/64k/syllabs/cmn-mi2.mp3', size: 8412 },
  { id: 'mi3', audioPath: '/audio/cmn/64k/syllabs/cmn-mi3.mp3', size: 11676 },
  { id: 'mi4', audioPath: '/audio/cmn/64k/syllabs/cmn-mi4.mp3', size: 8796 },
  {
    id: 'mian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mian1.mp3',
    size: 9952
  },
  {
    id: 'mian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mian2.mp3',
    size: 9568
  },
  {
    id: 'mian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mian3.mp3',
    size: 10720
  },
  {
    id: 'mian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-mian4.mp3',
    size: 8416
  },
  {
    id: 'miao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-miao1.mp3',
    size: 10336
  },
  {
    id: 'miao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-miao2.mp3',
    size: 9568
  },
  {
    id: 'miao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-miao3.mp3',
    size: 12064
  },
  {
    id: 'miao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-miao4.mp3',
    size: 9184
  },
  { id: 'mie1', audioPath: '/audio/cmn/64k/syllabs/cmn-mie1.mp3', size: 9182 },
  { id: 'mie2', audioPath: '/audio/cmn/64k/syllabs/cmn-mie2.mp3', size: 8798 },
  { id: 'mie3', audioPath: '/audio/cmn/64k/syllabs/cmn-mie3.mp3', size: 10718 },
  { id: 'mie4', audioPath: '/audio/cmn/64k/syllabs/cmn-mie4.mp3', size: 8414 },
  { id: 'min1', audioPath: '/audio/cmn/64k/syllabs/cmn-min1.mp3', size: 9182 },
  { id: 'min2', audioPath: '/audio/cmn/64k/syllabs/cmn-min2.mp3', size: 9566 },
  { id: 'min3', audioPath: '/audio/cmn/64k/syllabs/cmn-min3.mp3', size: 9566 },
  { id: 'min4', audioPath: '/audio/cmn/64k/syllabs/cmn-min4.mp3', size: 9182 },
  {
    id: 'ming1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ming1.mp3',
    size: 9568
  },
  {
    id: 'ming2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ming2.mp3',
    size: 9184
  },
  {
    id: 'ming3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ming3.mp3',
    size: 10336
  },
  {
    id: 'ming4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ming4.mp3',
    size: 9184
  },
  { id: 'miu1', audioPath: '/audio/cmn/64k/syllabs/cmn-miu1.mp3', size: 9566 },
  { id: 'miu2', audioPath: '/audio/cmn/64k/syllabs/cmn-miu2.mp3', size: 9566 },
  { id: 'miu3', audioPath: '/audio/cmn/64k/syllabs/cmn-miu3.mp3', size: 10334 },
  { id: 'miu4', audioPath: '/audio/cmn/64k/syllabs/cmn-miu4.mp3', size: 8414 },
  { id: 'mo1', audioPath: '/audio/cmn/64k/syllabs/cmn-mo1.mp3', size: 9180 },
  { id: 'mo2', audioPath: '/audio/cmn/64k/syllabs/cmn-mo2.mp3', size: 9180 },
  { id: 'mo3', audioPath: '/audio/cmn/64k/syllabs/cmn-mo3.mp3', size: 12060 },
  { id: 'mo4', audioPath: '/audio/cmn/64k/syllabs/cmn-mo4.mp3', size: 9180 },
  { id: 'mou1', audioPath: '/audio/cmn/64k/syllabs/cmn-mou1.mp3', size: 9566 },
  { id: 'mou2', audioPath: '/audio/cmn/64k/syllabs/cmn-mou2.mp3', size: 9566 },
  { id: 'mou3', audioPath: '/audio/cmn/64k/syllabs/cmn-mou3.mp3', size: 11678 },
  { id: 'mou4', audioPath: '/audio/cmn/64k/syllabs/cmn-mou4.mp3', size: 9182 },
  { id: 'mu1', audioPath: '/audio/cmn/64k/syllabs/cmn-mu1.mp3', size: 8412 },
  { id: 'mu2', audioPath: '/audio/cmn/64k/syllabs/cmn-mu2.mp3', size: 9180 },
  { id: 'mu3', audioPath: '/audio/cmn/64k/syllabs/cmn-mu3.mp3', size: 11676 },
  { id: 'mu4', audioPath: '/audio/cmn/64k/syllabs/cmn-mu4.mp3', size: 9180 },
  { id: 'na1', audioPath: '/audio/cmn/64k/syllabs/cmn-na1.mp3', size: 8412 },
  { id: 'na2', audioPath: '/audio/cmn/64k/syllabs/cmn-na2.mp3', size: 9564 },
  { id: 'na3', audioPath: '/audio/cmn/64k/syllabs/cmn-na3.mp3', size: 10716 },
  { id: 'na4', audioPath: '/audio/cmn/64k/syllabs/cmn-na4.mp3', size: 8028 },
  { id: 'nai1', audioPath: '/audio/cmn/64k/syllabs/cmn-nai1.mp3', size: 9566 },
  { id: 'nai2', audioPath: '/audio/cmn/64k/syllabs/cmn-nai2.mp3', size: 8798 },
  { id: 'nai3', audioPath: '/audio/cmn/64k/syllabs/cmn-nai3.mp3', size: 11294 },
  { id: 'nai4', audioPath: '/audio/cmn/64k/syllabs/cmn-nai4.mp3', size: 9950 },
  { id: 'nan1', audioPath: '/audio/cmn/64k/syllabs/cmn-nan1.mp3', size: 9566 },
  { id: 'nan2', audioPath: '/audio/cmn/64k/syllabs/cmn-nan2.mp3', size: 9950 },
  { id: 'nan3', audioPath: '/audio/cmn/64k/syllabs/cmn-nan3.mp3', size: 10334 },
  { id: 'nan4', audioPath: '/audio/cmn/64k/syllabs/cmn-nan4.mp3', size: 9566 },
  {
    id: 'nang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nang1.mp3',
    size: 9952
  },
  {
    id: 'nang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nang2.mp3',
    size: 9952
  },
  {
    id: 'nang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nang3.mp3',
    size: 9952
  },
  {
    id: 'nang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nang4.mp3',
    size: 9184
  },
  { id: 'nao1', audioPath: '/audio/cmn/64k/syllabs/cmn-nao1.mp3', size: 8414 },
  { id: 'nao2', audioPath: '/audio/cmn/64k/syllabs/cmn-nao2.mp3', size: 8798 },
  { id: 'nao3', audioPath: '/audio/cmn/64k/syllabs/cmn-nao3.mp3', size: 12830 },
  { id: 'nao4', audioPath: '/audio/cmn/64k/syllabs/cmn-nao4.mp3', size: 9566 },
  { id: 'ne1', audioPath: '/audio/cmn/64k/syllabs/cmn-ne1.mp3', size: 8028 },
  { id: 'ne2', audioPath: '/audio/cmn/64k/syllabs/cmn-ne2.mp3', size: 9180 },
  { id: 'ne3', audioPath: '/audio/cmn/64k/syllabs/cmn-ne3.mp3', size: 12444 },
  { id: 'ne4', audioPath: '/audio/cmn/64k/syllabs/cmn-ne4.mp3', size: 9180 },
  { id: 'nei1', audioPath: '/audio/cmn/64k/syllabs/cmn-nei1.mp3', size: 9566 },
  { id: 'nei2', audioPath: '/audio/cmn/64k/syllabs/cmn-nei2.mp3', size: 9950 },
  { id: 'nei3', audioPath: '/audio/cmn/64k/syllabs/cmn-nei3.mp3', size: 12062 },
  { id: 'nei4', audioPath: '/audio/cmn/64k/syllabs/cmn-nei4.mp3', size: 9182 },
  { id: 'nen1', audioPath: '/audio/cmn/64k/syllabs/cmn-nen1.mp3', size: 10334 },
  { id: 'nen2', audioPath: '/audio/cmn/64k/syllabs/cmn-nen2.mp3', size: 9182 },
  { id: 'nen3', audioPath: '/audio/cmn/64k/syllabs/cmn-nen3.mp3', size: 10718 },
  { id: 'nen4', audioPath: '/audio/cmn/64k/syllabs/cmn-nen4.mp3', size: 8030 },
  {
    id: 'neng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-neng1.mp3',
    size: 9952
  },
  {
    id: 'neng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-neng2.mp3',
    size: 8800
  },
  {
    id: 'neng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-neng3.mp3',
    size: 13216
  },
  {
    id: 'neng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-neng4.mp3',
    size: 9568
  },
  { id: 'ni1', audioPath: '/audio/cmn/64k/syllabs/cmn-ni1.mp3', size: 9564 },
  { id: 'ni2', audioPath: '/audio/cmn/64k/syllabs/cmn-ni2.mp3', size: 9180 },
  { id: 'ni3', audioPath: '/audio/cmn/64k/syllabs/cmn-ni3.mp3', size: 11292 },
  { id: 'ni4', audioPath: '/audio/cmn/64k/syllabs/cmn-ni4.mp3', size: 9180 },
  {
    id: 'nian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nian1.mp3',
    size: 9952
  },
  {
    id: 'nian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nian2.mp3',
    size: 9952
  },
  {
    id: 'nian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nian3.mp3',
    size: 12832
  },
  {
    id: 'nian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nian4.mp3',
    size: 8800
  },
  {
    id: 'niang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niang1.mp3',
    size: 9186
  },
  {
    id: 'niang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niang2.mp3',
    size: 11298
  },
  {
    id: 'niang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niang3.mp3',
    size: 12066
  },
  {
    id: 'niang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niang4.mp3',
    size: 9186
  },
  {
    id: 'niao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niao1.mp3',
    size: 9184
  },
  {
    id: 'niao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niao2.mp3',
    size: 10720
  },
  {
    id: 'niao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niao3.mp3',
    size: 10720
  },
  {
    id: 'niao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-niao4.mp3',
    size: 9184
  },
  { id: 'nie1', audioPath: '/audio/cmn/64k/syllabs/cmn-nie1.mp3', size: 8030 },
  { id: 'nie2', audioPath: '/audio/cmn/64k/syllabs/cmn-nie2.mp3', size: 8798 },
  { id: 'nie3', audioPath: '/audio/cmn/64k/syllabs/cmn-nie3.mp3', size: 11294 },
  { id: 'nie4', audioPath: '/audio/cmn/64k/syllabs/cmn-nie4.mp3', size: 9566 },
  { id: 'nin1', audioPath: '/audio/cmn/64k/syllabs/cmn-nin1.mp3', size: 9182 },
  { id: 'nin2', audioPath: '/audio/cmn/64k/syllabs/cmn-nin2.mp3', size: 9950 },
  { id: 'nin3', audioPath: '/audio/cmn/64k/syllabs/cmn-nin3.mp3', size: 10334 },
  { id: 'nin4', audioPath: '/audio/cmn/64k/syllabs/cmn-nin4.mp3', size: 9566 },
  {
    id: 'ning1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ning1.mp3',
    size: 9952
  },
  {
    id: 'ning2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ning2.mp3',
    size: 9568
  },
  {
    id: 'ning3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ning3.mp3',
    size: 11296
  },
  {
    id: 'ning4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ning4.mp3',
    size: 9184
  },
  { id: 'niu1', audioPath: '/audio/cmn/64k/syllabs/cmn-niu1.mp3', size: 9566 },
  { id: 'niu2', audioPath: '/audio/cmn/64k/syllabs/cmn-niu2.mp3', size: 9182 },
  { id: 'niu3', audioPath: '/audio/cmn/64k/syllabs/cmn-niu3.mp3', size: 11678 },
  { id: 'niu4', audioPath: '/audio/cmn/64k/syllabs/cmn-niu4.mp3', size: 9566 },
  {
    id: 'nong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nong1.mp3',
    size: 9952
  },
  {
    id: 'nong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nong2.mp3',
    size: 10336
  },
  {
    id: 'nong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nong3.mp3',
    size: 12448
  },
  {
    id: 'nong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nong4.mp3',
    size: 8032
  },
  { id: 'nou1', audioPath: '/audio/cmn/64k/syllabs/cmn-nou1.mp3', size: 9566 },
  { id: 'nou2', audioPath: '/audio/cmn/64k/syllabs/cmn-nou2.mp3', size: 9566 },
  { id: 'nou3', audioPath: '/audio/cmn/64k/syllabs/cmn-nou3.mp3', size: 12446 },
  { id: 'nou4', audioPath: '/audio/cmn/64k/syllabs/cmn-nou4.mp3', size: 9566 },
  { id: 'nu1', audioPath: '/audio/cmn/64k/syllabs/cmn-nu1.mp3', size: 9564 },
  { id: 'nu2', audioPath: '/audio/cmn/64k/syllabs/cmn-nu2.mp3', size: 8796 },
  { id: 'nu3', audioPath: '/audio/cmn/64k/syllabs/cmn-nu3.mp3', size: 11292 },
  { id: 'nu4', audioPath: '/audio/cmn/64k/syllabs/cmn-nu4.mp3', size: 9564 },
  {
    id: 'nuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nuan1.mp3',
    size: 10336
  },
  {
    id: 'nuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nuan2.mp3',
    size: 10336
  },
  {
    id: 'nuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nuan3.mp3',
    size: 12832
  },
  {
    id: 'nuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-nuan4.mp3',
    size: 9184
  },
  { id: 'nun1', audioPath: '/audio/cmn/64k/syllabs/cmn-nun1.mp3', size: 9950 },
  { id: 'nun2', audioPath: '/audio/cmn/64k/syllabs/cmn-nun2.mp3', size: 9182 },
  { id: 'nun3', audioPath: '/audio/cmn/64k/syllabs/cmn-nun3.mp3', size: 12830 },
  { id: 'nun4', audioPath: '/audio/cmn/64k/syllabs/cmn-nun4.mp3', size: 9950 },
  { id: 'nuo1', audioPath: '/audio/cmn/64k/syllabs/cmn-nuo1.mp3', size: 9566 },
  { id: 'nuo2', audioPath: '/audio/cmn/64k/syllabs/cmn-nuo2.mp3', size: 8414 },
  { id: 'nuo3', audioPath: '/audio/cmn/64k/syllabs/cmn-nuo3.mp3', size: 12446 },
  { id: 'nuo4', audioPath: '/audio/cmn/64k/syllabs/cmn-nuo4.mp3', size: 8798 },
  { id: 'nv1', audioPath: '/audio/cmn/64k/syllabs/cmn-nv1.mp3', size: 8412 },
  { id: 'nv2', audioPath: '/audio/cmn/64k/syllabs/cmn-nv2.mp3', size: 8412 },
  { id: 'nv3', audioPath: '/audio/cmn/64k/syllabs/cmn-nv3.mp3', size: 12060 },
  { id: 'nv4', audioPath: '/audio/cmn/64k/syllabs/cmn-nv4.mp3', size: 8796 },
  { id: 'nve1', audioPath: '/audio/cmn/64k/syllabs/cmn-nve1.mp3', size: 9566 },
  { id: 'nve2', audioPath: '/audio/cmn/64k/syllabs/cmn-nve2.mp3', size: 8798 },
  { id: 'nve3', audioPath: '/audio/cmn/64k/syllabs/cmn-nve3.mp3', size: 11294 },
  { id: 'nve4', audioPath: '/audio/cmn/64k/syllabs/cmn-nve4.mp3', size: 8414 },
  { id: 'o1', audioPath: '/audio/cmn/64k/syllabs/cmn-o1.mp3', size: 8026 },
  { id: 'o2', audioPath: '/audio/cmn/64k/syllabs/cmn-o2.mp3', size: 8410 },
  { id: 'o3', audioPath: '/audio/cmn/64k/syllabs/cmn-o3.mp3', size: 12058 },
  { id: 'o4', audioPath: '/audio/cmn/64k/syllabs/cmn-o4.mp3', size: 8026 },
  { id: 'ou1', audioPath: '/audio/cmn/64k/syllabs/cmn-ou1.mp3', size: 8796 },
  { id: 'ou2', audioPath: '/audio/cmn/64k/syllabs/cmn-ou2.mp3', size: 8796 },
  { id: 'ou3', audioPath: '/audio/cmn/64k/syllabs/cmn-ou3.mp3', size: 11292 },
  { id: 'ou4', audioPath: '/audio/cmn/64k/syllabs/cmn-ou4.mp3', size: 8796 },
  { id: 'pa1', audioPath: '/audio/cmn/64k/syllabs/cmn-pa1.mp3', size: 8412 },
  { id: 'pa2', audioPath: '/audio/cmn/64k/syllabs/cmn-pa2.mp3', size: 8412 },
  { id: 'pa3', audioPath: '/audio/cmn/64k/syllabs/cmn-pa3.mp3', size: 12060 },
  { id: 'pa4', audioPath: '/audio/cmn/64k/syllabs/cmn-pa4.mp3', size: 8796 },
  { id: 'pai1', audioPath: '/audio/cmn/64k/syllabs/cmn-pai1.mp3', size: 8798 },
  { id: 'pai2', audioPath: '/audio/cmn/64k/syllabs/cmn-pai2.mp3', size: 9566 },
  { id: 'pai3', audioPath: '/audio/cmn/64k/syllabs/cmn-pai3.mp3', size: 12830 },
  { id: 'pai4', audioPath: '/audio/cmn/64k/syllabs/cmn-pai4.mp3', size: 8414 },
  { id: 'pan1', audioPath: '/audio/cmn/64k/syllabs/cmn-pan1.mp3', size: 9566 },
  { id: 'pan2', audioPath: '/audio/cmn/64k/syllabs/cmn-pan2.mp3', size: 9950 },
  { id: 'pan3', audioPath: '/audio/cmn/64k/syllabs/cmn-pan3.mp3', size: 11678 },
  { id: 'pan4', audioPath: '/audio/cmn/64k/syllabs/cmn-pan4.mp3', size: 8798 },
  {
    id: 'pang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pang1.mp3',
    size: 9184
  },
  {
    id: 'pang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pang2.mp3',
    size: 9568
  },
  {
    id: 'pang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pang3.mp3',
    size: 9952
  },
  {
    id: 'pang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pang4.mp3',
    size: 8800
  },
  { id: 'pao1', audioPath: '/audio/cmn/64k/syllabs/cmn-pao1.mp3', size: 8414 },
  { id: 'pao2', audioPath: '/audio/cmn/64k/syllabs/cmn-pao2.mp3', size: 9566 },
  { id: 'pao3', audioPath: '/audio/cmn/64k/syllabs/cmn-pao3.mp3', size: 12062 },
  { id: 'pao4', audioPath: '/audio/cmn/64k/syllabs/cmn-pao4.mp3', size: 9182 },
  { id: 'pei1', audioPath: '/audio/cmn/64k/syllabs/cmn-pei1.mp3', size: 8798 },
  { id: 'pei2', audioPath: '/audio/cmn/64k/syllabs/cmn-pei2.mp3', size: 9182 },
  { id: 'pei3', audioPath: '/audio/cmn/64k/syllabs/cmn-pei3.mp3', size: 12062 },
  { id: 'pei4', audioPath: '/audio/cmn/64k/syllabs/cmn-pei4.mp3', size: 9182 },
  { id: 'pen1', audioPath: '/audio/cmn/64k/syllabs/cmn-pen1.mp3', size: 8414 },
  { id: 'pen2', audioPath: '/audio/cmn/64k/syllabs/cmn-pen2.mp3', size: 8414 },
  { id: 'pen3', audioPath: '/audio/cmn/64k/syllabs/cmn-pen3.mp3', size: 11678 },
  { id: 'pen4', audioPath: '/audio/cmn/64k/syllabs/cmn-pen4.mp3', size: 8798 },
  {
    id: 'peng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-peng1.mp3',
    size: 9568
  },
  {
    id: 'peng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-peng2.mp3',
    size: 9184
  },
  {
    id: 'peng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-peng3.mp3',
    size: 11680
  },
  {
    id: 'peng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-peng4.mp3',
    size: 8416
  },
  { id: 'pi1', audioPath: '/audio/cmn/64k/syllabs/cmn-pi1.mp3', size: 9564 },
  { id: 'pi2', audioPath: '/audio/cmn/64k/syllabs/cmn-pi2.mp3', size: 8412 },
  { id: 'pi3', audioPath: '/audio/cmn/64k/syllabs/cmn-pi3.mp3', size: 12444 },
  { id: 'pi4', audioPath: '/audio/cmn/64k/syllabs/cmn-pi4.mp3', size: 9180 },
  {
    id: 'pian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pian1.mp3',
    size: 10336
  },
  {
    id: 'pian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pian2.mp3',
    size: 9952
  },
  {
    id: 'pian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pian3.mp3',
    size: 12448
  },
  {
    id: 'pian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-pian4.mp3',
    size: 9568
  },
  {
    id: 'piao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-piao1.mp3',
    size: 8032
  },
  {
    id: 'piao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-piao2.mp3',
    size: 8800
  },
  {
    id: 'piao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-piao3.mp3',
    size: 11680
  },
  {
    id: 'piao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-piao4.mp3',
    size: 9568
  },
  { id: 'pie1', audioPath: '/audio/cmn/64k/syllabs/cmn-pie1.mp3', size: 9566 },
  { id: 'pie2', audioPath: '/audio/cmn/64k/syllabs/cmn-pie2.mp3', size: 9950 },
  { id: 'pie3', audioPath: '/audio/cmn/64k/syllabs/cmn-pie3.mp3', size: 11294 },
  { id: 'pie4', audioPath: '/audio/cmn/64k/syllabs/cmn-pie4.mp3', size: 9566 },
  { id: 'pin1', audioPath: '/audio/cmn/64k/syllabs/cmn-pin1.mp3', size: 8798 },
  { id: 'pin2', audioPath: '/audio/cmn/64k/syllabs/cmn-pin2.mp3', size: 9182 },
  { id: 'pin3', audioPath: '/audio/cmn/64k/syllabs/cmn-pin3.mp3', size: 11678 },
  { id: 'pin4', audioPath: '/audio/cmn/64k/syllabs/cmn-pin4.mp3', size: 9182 },
  {
    id: 'ping1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ping1.mp3',
    size: 9184
  },
  {
    id: 'ping2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ping2.mp3',
    size: 9568
  },
  {
    id: 'ping3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ping3.mp3',
    size: 12832
  },
  {
    id: 'ping4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ping4.mp3',
    size: 9568
  },
  { id: 'po1', audioPath: '/audio/cmn/64k/syllabs/cmn-po1.mp3', size: 8796 },
  { id: 'po2', audioPath: '/audio/cmn/64k/syllabs/cmn-po2.mp3', size: 9948 },
  { id: 'po3', audioPath: '/audio/cmn/64k/syllabs/cmn-po3.mp3', size: 12060 },
  { id: 'po4', audioPath: '/audio/cmn/64k/syllabs/cmn-po4.mp3', size: 9564 },
  { id: 'pou1', audioPath: '/audio/cmn/64k/syllabs/cmn-pou1.mp3', size: 9182 },
  { id: 'pou2', audioPath: '/audio/cmn/64k/syllabs/cmn-pou2.mp3', size: 8798 },
  { id: 'pou3', audioPath: '/audio/cmn/64k/syllabs/cmn-pou3.mp3', size: 10334 },
  { id: 'pou4', audioPath: '/audio/cmn/64k/syllabs/cmn-pou4.mp3', size: 8798 },
  { id: 'pu1', audioPath: '/audio/cmn/64k/syllabs/cmn-pu1.mp3', size: 8796 },
  { id: 'pu2', audioPath: '/audio/cmn/64k/syllabs/cmn-pu2.mp3', size: 9564 },
  { id: 'pu3', audioPath: '/audio/cmn/64k/syllabs/cmn-pu3.mp3', size: 11676 },
  { id: 'pu4', audioPath: '/audio/cmn/64k/syllabs/cmn-pu4.mp3', size: 9564 },
  { id: 'qi1', audioPath: '/audio/cmn/64k/syllabs/cmn-qi1.mp3', size: 9948 },
  { id: 'qi2', audioPath: '/audio/cmn/64k/syllabs/cmn-qi2.mp3', size: 10332 },
  { id: 'qi3', audioPath: '/audio/cmn/64k/syllabs/cmn-qi3.mp3', size: 12828 },
  { id: 'qi4', audioPath: '/audio/cmn/64k/syllabs/cmn-qi4.mp3', size: 9948 },
  { id: 'qia1', audioPath: '/audio/cmn/64k/syllabs/cmn-qia1.mp3', size: 8414 },
  { id: 'qia2', audioPath: '/audio/cmn/64k/syllabs/cmn-qia2.mp3', size: 10334 },
  { id: 'qia3', audioPath: '/audio/cmn/64k/syllabs/cmn-qia3.mp3', size: 11678 },
  { id: 'qia4', audioPath: '/audio/cmn/64k/syllabs/cmn-qia4.mp3', size: 9950 },
  {
    id: 'qian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qian1.mp3',
    size: 9568
  },
  {
    id: 'qian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qian2.mp3',
    size: 9952
  },
  {
    id: 'qian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qian3.mp3',
    size: 12448
  },
  {
    id: 'qian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qian4.mp3',
    size: 9952
  },
  {
    id: 'qiang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiang1.mp3',
    size: 10338
  },
  {
    id: 'qiang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiang2.mp3',
    size: 10338
  },
  {
    id: 'qiang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiang3.mp3',
    size: 11298
  },
  {
    id: 'qiang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiang4.mp3',
    size: 9954
  },
  {
    id: 'qiao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiao1.mp3',
    size: 10336
  },
  {
    id: 'qiao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiao2.mp3',
    size: 9568
  },
  {
    id: 'qiao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiao3.mp3',
    size: 12448
  },
  {
    id: 'qiao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiao4.mp3',
    size: 9952
  },
  { id: 'qie1', audioPath: '/audio/cmn/64k/syllabs/cmn-qie1.mp3', size: 10334 },
  { id: 'qie2', audioPath: '/audio/cmn/64k/syllabs/cmn-qie2.mp3', size: 10334 },
  { id: 'qie3', audioPath: '/audio/cmn/64k/syllabs/cmn-qie3.mp3', size: 12062 },
  { id: 'qie4', audioPath: '/audio/cmn/64k/syllabs/cmn-qie4.mp3', size: 10334 },
  { id: 'qin1', audioPath: '/audio/cmn/64k/syllabs/cmn-qin1.mp3', size: 8798 },
  { id: 'qin2', audioPath: '/audio/cmn/64k/syllabs/cmn-qin2.mp3', size: 9566 },
  { id: 'qin3', audioPath: '/audio/cmn/64k/syllabs/cmn-qin3.mp3', size: 12830 },
  { id: 'qin4', audioPath: '/audio/cmn/64k/syllabs/cmn-qin4.mp3', size: 9950 },
  {
    id: 'qing1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qing1.mp3',
    size: 10720
  },
  {
    id: 'qing2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qing2.mp3',
    size: 10336
  },
  {
    id: 'qing3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qing3.mp3',
    size: 12832
  },
  {
    id: 'qing4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qing4.mp3',
    size: 9952
  },
  {
    id: 'qiong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiong1.mp3',
    size: 10338
  },
  {
    id: 'qiong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiong2.mp3',
    size: 10338
  },
  {
    id: 'qiong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiong3.mp3',
    size: 10722
  },
  {
    id: 'qiong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-qiong4.mp3',
    size: 9954
  },
  { id: 'qiu1', audioPath: '/audio/cmn/64k/syllabs/cmn-qiu1.mp3', size: 9950 },
  { id: 'qiu2', audioPath: '/audio/cmn/64k/syllabs/cmn-qiu2.mp3', size: 9566 },
  { id: 'qiu3', audioPath: '/audio/cmn/64k/syllabs/cmn-qiu3.mp3', size: 12446 },
  { id: 'qiu4', audioPath: '/audio/cmn/64k/syllabs/cmn-qiu4.mp3', size: 10334 },
  { id: 'qu1', audioPath: '/audio/cmn/64k/syllabs/cmn-qu1.mp3', size: 9564 },
  { id: 'qu2', audioPath: '/audio/cmn/64k/syllabs/cmn-qu2.mp3', size: 9948 },
  { id: 'qu3', audioPath: '/audio/cmn/64k/syllabs/cmn-qu3.mp3', size: 11292 },
  { id: 'qu4', audioPath: '/audio/cmn/64k/syllabs/cmn-qu4.mp3', size: 8796 },
  {
    id: 'quan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-quan1.mp3',
    size: 9568
  },
  {
    id: 'quan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-quan2.mp3',
    size: 9952
  },
  {
    id: 'quan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-quan3.mp3',
    size: 11680
  },
  {
    id: 'quan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-quan4.mp3',
    size: 9952
  },
  { id: 'que1', audioPath: '/audio/cmn/64k/syllabs/cmn-que1.mp3', size: 8798 },
  { id: 'que2', audioPath: '/audio/cmn/64k/syllabs/cmn-que2.mp3', size: 9182 },
  { id: 'que3', audioPath: '/audio/cmn/64k/syllabs/cmn-que3.mp3', size: 13214 },
  { id: 'que4', audioPath: '/audio/cmn/64k/syllabs/cmn-que4.mp3', size: 9182 },
  { id: 'qun1', audioPath: '/audio/cmn/64k/syllabs/cmn-qun1.mp3', size: 9950 },
  { id: 'qun2', audioPath: '/audio/cmn/64k/syllabs/cmn-qun2.mp3', size: 9950 },
  { id: 'qun3', audioPath: '/audio/cmn/64k/syllabs/cmn-qun3.mp3', size: 13598 },
  { id: 'qun4', audioPath: '/audio/cmn/64k/syllabs/cmn-qun4.mp3', size: 9950 },
  { id: 'ran1', audioPath: '/audio/cmn/64k/syllabs/cmn-ran1.mp3', size: 9950 },
  { id: 'ran2', audioPath: '/audio/cmn/64k/syllabs/cmn-ran2.mp3', size: 9950 },
  { id: 'ran3', audioPath: '/audio/cmn/64k/syllabs/cmn-ran3.mp3', size: 12446 },
  { id: 'ran4', audioPath: '/audio/cmn/64k/syllabs/cmn-ran4.mp3', size: 9182 },
  {
    id: 'rang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rang1.mp3',
    size: 9568
  },
  {
    id: 'rang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rang2.mp3',
    size: 10720
  },
  {
    id: 'rang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rang3.mp3',
    size: 10336
  },
  {
    id: 'rang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rang4.mp3',
    size: 9568
  },
  { id: 'rao1', audioPath: '/audio/cmn/64k/syllabs/cmn-rao1.mp3', size: 9566 },
  { id: 'rao2', audioPath: '/audio/cmn/64k/syllabs/cmn-rao2.mp3', size: 9566 },
  { id: 'rao3', audioPath: '/audio/cmn/64k/syllabs/cmn-rao3.mp3', size: 13214 },
  { id: 'rao4', audioPath: '/audio/cmn/64k/syllabs/cmn-rao4.mp3', size: 9950 },
  { id: 're1', audioPath: '/audio/cmn/64k/syllabs/cmn-re1.mp3', size: 9180 },
  { id: 're2', audioPath: '/audio/cmn/64k/syllabs/cmn-re2.mp3', size: 9948 },
  { id: 're3', audioPath: '/audio/cmn/64k/syllabs/cmn-re3.mp3', size: 12828 },
  { id: 're4', audioPath: '/audio/cmn/64k/syllabs/cmn-re4.mp3', size: 8412 },
  { id: 'ren1', audioPath: '/audio/cmn/64k/syllabs/cmn-ren1.mp3', size: 9950 },
  { id: 'ren2', audioPath: '/audio/cmn/64k/syllabs/cmn-ren2.mp3', size: 9566 },
  { id: 'ren3', audioPath: '/audio/cmn/64k/syllabs/cmn-ren3.mp3', size: 13598 },
  { id: 'ren4', audioPath: '/audio/cmn/64k/syllabs/cmn-ren4.mp3', size: 9566 },
  {
    id: 'reng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-reng1.mp3',
    size: 9952
  },
  {
    id: 'reng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-reng2.mp3',
    size: 10336
  },
  {
    id: 'reng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-reng3.mp3',
    size: 11680
  },
  {
    id: 'reng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-reng4.mp3',
    size: 9184
  },
  { id: 'ri1', audioPath: '/audio/cmn/64k/syllabs/cmn-ri1.mp3', size: 8796 },
  { id: 'ri2', audioPath: '/audio/cmn/64k/syllabs/cmn-ri2.mp3', size: 9948 },
  { id: 'ri3', audioPath: '/audio/cmn/64k/syllabs/cmn-ri3.mp3', size: 11292 },
  { id: 'ri4', audioPath: '/audio/cmn/64k/syllabs/cmn-ri4.mp3', size: 9180 },
  {
    id: 'rong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rong1.mp3',
    size: 9952
  },
  {
    id: 'rong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rong2.mp3',
    size: 8800
  },
  {
    id: 'rong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rong3.mp3',
    size: 12064
  },
  {
    id: 'rong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-rong4.mp3',
    size: 9952
  },
  { id: 'rou1', audioPath: '/audio/cmn/64k/syllabs/cmn-rou1.mp3', size: 9950 },
  { id: 'rou2', audioPath: '/audio/cmn/64k/syllabs/cmn-rou2.mp3', size: 9566 },
  { id: 'rou3', audioPath: '/audio/cmn/64k/syllabs/cmn-rou3.mp3', size: 11678 },
  { id: 'rou4', audioPath: '/audio/cmn/64k/syllabs/cmn-rou4.mp3', size: 9566 },
  { id: 'ru1', audioPath: '/audio/cmn/64k/syllabs/cmn-ru1.mp3', size: 9948 },
  { id: 'ru2', audioPath: '/audio/cmn/64k/syllabs/cmn-ru2.mp3', size: 9564 },
  { id: 'ru3', audioPath: '/audio/cmn/64k/syllabs/cmn-ru3.mp3', size: 11676 },
  { id: 'ru4', audioPath: '/audio/cmn/64k/syllabs/cmn-ru4.mp3', size: 9948 },
  { id: 'rua1', audioPath: '/audio/cmn/64k/syllabs/cmn-rua1.mp3', size: 10334 },
  { id: 'rua2', audioPath: '/audio/cmn/64k/syllabs/cmn-rua2.mp3', size: 8030 },
  { id: 'rua3', audioPath: '/audio/cmn/64k/syllabs/cmn-rua3.mp3', size: 12062 },
  { id: 'rua4', audioPath: '/audio/cmn/64k/syllabs/cmn-rua4.mp3', size: 9950 },
  {
    id: 'ruan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ruan1.mp3',
    size: 9184
  },
  {
    id: 'ruan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ruan2.mp3',
    size: 9568
  },
  {
    id: 'ruan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ruan3.mp3',
    size: 12448
  },
  {
    id: 'ruan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ruan4.mp3',
    size: 10336
  },
  { id: 'rui1', audioPath: '/audio/cmn/64k/syllabs/cmn-rui1.mp3', size: 9950 },
  { id: 'rui2', audioPath: '/audio/cmn/64k/syllabs/cmn-rui2.mp3', size: 8030 },
  { id: 'rui3', audioPath: '/audio/cmn/64k/syllabs/cmn-rui3.mp3', size: 9950 },
  { id: 'rui4', audioPath: '/audio/cmn/64k/syllabs/cmn-rui4.mp3', size: 9182 },
  { id: 'run1', audioPath: '/audio/cmn/64k/syllabs/cmn-run1.mp3', size: 10334 },
  { id: 'run2', audioPath: '/audio/cmn/64k/syllabs/cmn-run2.mp3', size: 9566 },
  { id: 'run3', audioPath: '/audio/cmn/64k/syllabs/cmn-run3.mp3', size: 10334 },
  { id: 'run4', audioPath: '/audio/cmn/64k/syllabs/cmn-run4.mp3', size: 10334 },
  { id: 'ruo1', audioPath: '/audio/cmn/64k/syllabs/cmn-ruo1.mp3', size: 10334 },
  { id: 'ruo2', audioPath: '/audio/cmn/64k/syllabs/cmn-ruo2.mp3', size: 9566 },
  { id: 'ruo3', audioPath: '/audio/cmn/64k/syllabs/cmn-ruo3.mp3', size: 11678 },
  { id: 'ruo4', audioPath: '/audio/cmn/64k/syllabs/cmn-ruo4.mp3', size: 9950 },
  { id: 'sa1', audioPath: '/audio/cmn/64k/syllabs/cmn-sa1.mp3', size: 9180 },
  { id: 'sa2', audioPath: '/audio/cmn/64k/syllabs/cmn-sa2.mp3', size: 9564 },
  { id: 'sa3', audioPath: '/audio/cmn/64k/syllabs/cmn-sa3.mp3', size: 10716 },
  { id: 'sa4', audioPath: '/audio/cmn/64k/syllabs/cmn-sa4.mp3', size: 9948 },
  { id: 'sai1', audioPath: '/audio/cmn/64k/syllabs/cmn-sai1.mp3', size: 10334 },
  { id: 'sai2', audioPath: '/audio/cmn/64k/syllabs/cmn-sai2.mp3', size: 8414 },
  { id: 'sai3', audioPath: '/audio/cmn/64k/syllabs/cmn-sai3.mp3', size: 11678 },
  { id: 'sai4', audioPath: '/audio/cmn/64k/syllabs/cmn-sai4.mp3', size: 9182 },
  { id: 'san1', audioPath: '/audio/cmn/64k/syllabs/cmn-san1.mp3', size: 10334 },
  { id: 'san2', audioPath: '/audio/cmn/64k/syllabs/cmn-san2.mp3', size: 10334 },
  { id: 'san3', audioPath: '/audio/cmn/64k/syllabs/cmn-san3.mp3', size: 12830 },
  { id: 'san4', audioPath: '/audio/cmn/64k/syllabs/cmn-san4.mp3', size: 9950 },
  {
    id: 'sang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sang1.mp3',
    size: 9952
  },
  {
    id: 'sang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sang2.mp3',
    size: 9952
  },
  {
    id: 'sang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sang3.mp3',
    size: 12448
  },
  {
    id: 'sang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sang4.mp3',
    size: 10336
  },
  { id: 'sao1', audioPath: '/audio/cmn/64k/syllabs/cmn-sao1.mp3', size: 8798 },
  { id: 'sao2', audioPath: '/audio/cmn/64k/syllabs/cmn-sao2.mp3', size: 10334 },
  { id: 'sao3', audioPath: '/audio/cmn/64k/syllabs/cmn-sao3.mp3', size: 9182 },
  { id: 'sao4', audioPath: '/audio/cmn/64k/syllabs/cmn-sao4.mp3', size: 8798 },
  { id: 'se1', audioPath: '/audio/cmn/64k/syllabs/cmn-se1.mp3', size: 10332 },
  { id: 'se2', audioPath: '/audio/cmn/64k/syllabs/cmn-se2.mp3', size: 10332 },
  { id: 'se3', audioPath: '/audio/cmn/64k/syllabs/cmn-se3.mp3', size: 11292 },
  { id: 'se4', audioPath: '/audio/cmn/64k/syllabs/cmn-se4.mp3', size: 8796 },
  { id: 'sen1', audioPath: '/audio/cmn/64k/syllabs/cmn-sen1.mp3', size: 8798 },
  { id: 'sen2', audioPath: '/audio/cmn/64k/syllabs/cmn-sen2.mp3', size: 9566 },
  { id: 'sen3', audioPath: '/audio/cmn/64k/syllabs/cmn-sen3.mp3', size: 9950 },
  { id: 'sen4', audioPath: '/audio/cmn/64k/syllabs/cmn-sen4.mp3', size: 9566 },
  {
    id: 'seng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-seng1.mp3',
    size: 9952
  },
  {
    id: 'seng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-seng2.mp3',
    size: 9952
  },
  {
    id: 'seng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-seng3.mp3',
    size: 8416
  },
  {
    id: 'seng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-seng4.mp3',
    size: 10720
  },
  { id: 'sha1', audioPath: '/audio/cmn/64k/syllabs/cmn-sha1.mp3', size: 9182 },
  { id: 'sha2', audioPath: '/audio/cmn/64k/syllabs/cmn-sha2.mp3', size: 9950 },
  { id: 'sha3', audioPath: '/audio/cmn/64k/syllabs/cmn-sha3.mp3', size: 12446 },
  { id: 'sha4', audioPath: '/audio/cmn/64k/syllabs/cmn-sha4.mp3', size: 9182 },
  {
    id: 'shai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shai1.mp3',
    size: 10720
  },
  {
    id: 'shai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shai2.mp3',
    size: 9952
  },
  {
    id: 'shai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shai3.mp3',
    size: 12448
  },
  {
    id: 'shai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shai4.mp3',
    size: 9568
  },
  {
    id: 'shan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shan1.mp3',
    size: 10336
  },
  {
    id: 'shan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shan2.mp3',
    size: 9568
  },
  {
    id: 'shan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shan3.mp3',
    size: 12832
  },
  {
    id: 'shan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shan4.mp3',
    size: 10336
  },
  {
    id: 'shang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shang1.mp3',
    size: 10338
  },
  {
    id: 'shang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shang2.mp3',
    size: 9186
  },
  {
    id: 'shang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shang3.mp3',
    size: 12066
  },
  {
    id: 'shang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shang4.mp3',
    size: 10722
  },
  {
    id: 'shao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shao1.mp3',
    size: 9568
  },
  {
    id: 'shao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shao2.mp3',
    size: 9952
  },
  {
    id: 'shao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shao3.mp3',
    size: 12064
  },
  {
    id: 'shao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shao4.mp3',
    size: 9568
  },
  { id: 'she1', audioPath: '/audio/cmn/64k/syllabs/cmn-she1.mp3', size: 10334 },
  { id: 'she2', audioPath: '/audio/cmn/64k/syllabs/cmn-she2.mp3', size: 9950 },
  { id: 'she3', audioPath: '/audio/cmn/64k/syllabs/cmn-she3.mp3', size: 12062 },
  { id: 'she4', audioPath: '/audio/cmn/64k/syllabs/cmn-she4.mp3', size: 10718 },
  {
    id: 'shei1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shei1.mp3',
    size: 9184
  },
  {
    id: 'shei2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shei2.mp3',
    size: 10336
  },
  {
    id: 'shei3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shei3.mp3',
    size: 13216
  },
  {
    id: 'shei4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shei4.mp3',
    size: 10336
  },
  {
    id: 'shen1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shen1.mp3',
    size: 10336
  },
  {
    id: 'shen2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shen2.mp3',
    size: 10720
  },
  {
    id: 'shen3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shen3.mp3',
    size: 12448
  },
  {
    id: 'shen4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shen4.mp3',
    size: 10336
  },
  {
    id: 'sheng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sheng1.mp3',
    size: 9570
  },
  {
    id: 'sheng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sheng2.mp3',
    size: 9186
  },
  {
    id: 'sheng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sheng3.mp3',
    size: 10722
  },
  {
    id: 'sheng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-sheng4.mp3',
    size: 9570
  },
  { id: 'shi1', audioPath: '/audio/cmn/64k/syllabs/cmn-shi1.mp3', size: 9950 },
  { id: 'shi2', audioPath: '/audio/cmn/64k/syllabs/cmn-shi2.mp3', size: 10718 },
  { id: 'shi3', audioPath: '/audio/cmn/64k/syllabs/cmn-shi3.mp3', size: 12062 },
  { id: 'shi4', audioPath: '/audio/cmn/64k/syllabs/cmn-shi4.mp3', size: 9950 },
  {
    id: 'shou1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shou1.mp3',
    size: 8800
  },
  {
    id: 'shou2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shou2.mp3',
    size: 9952
  },
  {
    id: 'shou3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shou3.mp3',
    size: 12064
  },
  {
    id: 'shou4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shou4.mp3',
    size: 9952
  },
  { id: 'shu1', audioPath: '/audio/cmn/64k/syllabs/cmn-shu1.mp3', size: 9950 },
  { id: 'shu2', audioPath: '/audio/cmn/64k/syllabs/cmn-shu2.mp3', size: 9950 },
  { id: 'shu3', audioPath: '/audio/cmn/64k/syllabs/cmn-shu3.mp3', size: 13214 },
  { id: 'shu4', audioPath: '/audio/cmn/64k/syllabs/cmn-shu4.mp3', size: 8798 },
  {
    id: 'shua1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shua1.mp3',
    size: 9952
  },
  {
    id: 'shua2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shua2.mp3',
    size: 10336
  },
  {
    id: 'shua3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shua3.mp3',
    size: 13600
  },
  {
    id: 'shua4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shua4.mp3',
    size: 10336
  },
  {
    id: 'shuai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuai1.mp3',
    size: 10722
  },
  {
    id: 'shuai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuai2.mp3',
    size: 9954
  },
  {
    id: 'shuai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuai3.mp3',
    size: 12450
  },
  {
    id: 'shuai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuai4.mp3',
    size: 9186
  },
  {
    id: 'shuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuan1.mp3',
    size: 10338
  },
  {
    id: 'shuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuan2.mp3',
    size: 10722
  },
  {
    id: 'shuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuan3.mp3',
    size: 13602
  },
  {
    id: 'shuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuan4.mp3',
    size: 10722
  },
  {
    id: 'shuang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuang1.mp3',
    size: 11300
  },
  {
    id: 'shuang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuang2.mp3',
    size: 10340
  },
  {
    id: 'shuang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuang3.mp3',
    size: 10340
  },
  {
    id: 'shuang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuang4.mp3',
    size: 9956
  },
  {
    id: 'shui1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shui1.mp3',
    size: 9568
  },
  {
    id: 'shui2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shui2.mp3',
    size: 9952
  },
  {
    id: 'shui3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shui3.mp3',
    size: 11680
  },
  {
    id: 'shui4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shui4.mp3',
    size: 9952
  },
  {
    id: 'shun1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shun1.mp3',
    size: 9952
  },
  {
    id: 'shun2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shun2.mp3',
    size: 10336
  },
  {
    id: 'shun3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shun3.mp3',
    size: 11296
  },
  {
    id: 'shun4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shun4.mp3',
    size: 9568
  },
  {
    id: 'shuo1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuo1.mp3',
    size: 8800
  },
  {
    id: 'shuo2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuo2.mp3',
    size: 9952
  },
  {
    id: 'shuo3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuo3.mp3',
    size: 11296
  },
  {
    id: 'shuo4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-shuo4.mp3',
    size: 10336
  },
  { id: 'si1', audioPath: '/audio/cmn/64k/syllabs/cmn-si1.mp3', size: 10332 },
  { id: 'si2', audioPath: '/audio/cmn/64k/syllabs/cmn-si2.mp3', size: 9948 },
  { id: 'si3', audioPath: '/audio/cmn/64k/syllabs/cmn-si3.mp3', size: 12444 },
  { id: 'si4', audioPath: '/audio/cmn/64k/syllabs/cmn-si4.mp3', size: 9948 },
  {
    id: 'song1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-song1.mp3',
    size: 10720
  },
  {
    id: 'song2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-song2.mp3',
    size: 10720
  },
  {
    id: 'song3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-song3.mp3',
    size: 11680
  },
  {
    id: 'song4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-song4.mp3',
    size: 9952
  },
  { id: 'sou1', audioPath: '/audio/cmn/64k/syllabs/cmn-sou1.mp3', size: 9566 },
  { id: 'sou2', audioPath: '/audio/cmn/64k/syllabs/cmn-sou2.mp3', size: 9950 },
  { id: 'sou3', audioPath: '/audio/cmn/64k/syllabs/cmn-sou3.mp3', size: 12062 },
  { id: 'sou4', audioPath: '/audio/cmn/64k/syllabs/cmn-sou4.mp3', size: 8798 },
  { id: 'su1', audioPath: '/audio/cmn/64k/syllabs/cmn-su1.mp3', size: 9948 },
  { id: 'su2', audioPath: '/audio/cmn/64k/syllabs/cmn-su2.mp3', size: 10332 },
  { id: 'su3', audioPath: '/audio/cmn/64k/syllabs/cmn-su3.mp3', size: 12444 },
  { id: 'su4', audioPath: '/audio/cmn/64k/syllabs/cmn-su4.mp3', size: 8412 },
  {
    id: 'suan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-suan1.mp3',
    size: 11296
  },
  {
    id: 'suan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-suan2.mp3',
    size: 10336
  },
  {
    id: 'suan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-suan3.mp3',
    size: 11680
  },
  {
    id: 'suan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-suan4.mp3',
    size: 10720
  },
  { id: 'sui1', audioPath: '/audio/cmn/64k/syllabs/cmn-sui1.mp3', size: 8798 },
  { id: 'sui2', audioPath: '/audio/cmn/64k/syllabs/cmn-sui2.mp3', size: 9950 },
  { id: 'sui3', audioPath: '/audio/cmn/64k/syllabs/cmn-sui3.mp3', size: 9950 },
  { id: 'sui4', audioPath: '/audio/cmn/64k/syllabs/cmn-sui4.mp3', size: 10334 },
  { id: 'sun1', audioPath: '/audio/cmn/64k/syllabs/cmn-sun1.mp3', size: 10334 },
  { id: 'sun2', audioPath: '/audio/cmn/64k/syllabs/cmn-sun2.mp3', size: 11294 },
  { id: 'sun3', audioPath: '/audio/cmn/64k/syllabs/cmn-sun3.mp3', size: 12446 },
  { id: 'sun4', audioPath: '/audio/cmn/64k/syllabs/cmn-sun4.mp3', size: 10334 },
  { id: 'suo1', audioPath: '/audio/cmn/64k/syllabs/cmn-suo1.mp3', size: 10334 },
  { id: 'suo2', audioPath: '/audio/cmn/64k/syllabs/cmn-suo2.mp3', size: 9950 },
  { id: 'suo3', audioPath: '/audio/cmn/64k/syllabs/cmn-suo3.mp3', size: 12062 },
  { id: 'suo4', audioPath: '/audio/cmn/64k/syllabs/cmn-suo4.mp3', size: 9566 },
  { id: 'ta1', audioPath: '/audio/cmn/64k/syllabs/cmn-ta1.mp3', size: 8412 },
  { id: 'ta2', audioPath: '/audio/cmn/64k/syllabs/cmn-ta2.mp3', size: 9564 },
  { id: 'ta3', audioPath: '/audio/cmn/64k/syllabs/cmn-ta3.mp3', size: 9948 },
  { id: 'ta4', audioPath: '/audio/cmn/64k/syllabs/cmn-ta4.mp3', size: 8796 },
  { id: 'tai1', audioPath: '/audio/cmn/64k/syllabs/cmn-tai1.mp3', size: 9566 },
  { id: 'tai2', audioPath: '/audio/cmn/64k/syllabs/cmn-tai2.mp3', size: 9566 },
  { id: 'tai3', audioPath: '/audio/cmn/64k/syllabs/cmn-tai3.mp3', size: 11678 },
  { id: 'tai4', audioPath: '/audio/cmn/64k/syllabs/cmn-tai4.mp3', size: 9182 },
  { id: 'tan1', audioPath: '/audio/cmn/64k/syllabs/cmn-tan1.mp3', size: 9950 },
  { id: 'tan2', audioPath: '/audio/cmn/64k/syllabs/cmn-tan2.mp3', size: 9950 },
  { id: 'tan3', audioPath: '/audio/cmn/64k/syllabs/cmn-tan3.mp3', size: 12446 },
  { id: 'tan4', audioPath: '/audio/cmn/64k/syllabs/cmn-tan4.mp3', size: 9182 },
  {
    id: 'tang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tang1.mp3',
    size: 9568
  },
  {
    id: 'tang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tang2.mp3',
    size: 9184
  },
  {
    id: 'tang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tang3.mp3',
    size: 9952
  },
  {
    id: 'tang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tang4.mp3',
    size: 8416
  },
  { id: 'tao1', audioPath: '/audio/cmn/64k/syllabs/cmn-tao1.mp3', size: 9566 },
  { id: 'tao2', audioPath: '/audio/cmn/64k/syllabs/cmn-tao2.mp3', size: 9182 },
  { id: 'tao3', audioPath: '/audio/cmn/64k/syllabs/cmn-tao3.mp3', size: 10718 },
  { id: 'tao4', audioPath: '/audio/cmn/64k/syllabs/cmn-tao4.mp3', size: 9182 },
  { id: 'te1', audioPath: '/audio/cmn/64k/syllabs/cmn-te1.mp3', size: 9564 },
  { id: 'te2', audioPath: '/audio/cmn/64k/syllabs/cmn-te2.mp3', size: 8796 },
  { id: 'te3', audioPath: '/audio/cmn/64k/syllabs/cmn-te3.mp3', size: 12060 },
  { id: 'te4', audioPath: '/audio/cmn/64k/syllabs/cmn-te4.mp3', size: 8412 },
  { id: 'tei1', audioPath: '/audio/cmn/64k/syllabs/cmn-tei1.mp3', size: 8798 },
  { id: 'tei2', audioPath: '/audio/cmn/64k/syllabs/cmn-tei2.mp3', size: 8414 },
  { id: 'tei3', audioPath: '/audio/cmn/64k/syllabs/cmn-tei3.mp3', size: 12062 },
  { id: 'tei4', audioPath: '/audio/cmn/64k/syllabs/cmn-tei4.mp3', size: 8414 },
  {
    id: 'teng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-teng1.mp3',
    size: 9184
  },
  {
    id: 'teng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-teng2.mp3',
    size: 9568
  },
  {
    id: 'teng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-teng3.mp3',
    size: 10336
  },
  {
    id: 'teng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-teng4.mp3',
    size: 9184
  },
  { id: 'ti1', audioPath: '/audio/cmn/64k/syllabs/cmn-ti1.mp3', size: 8796 },
  { id: 'ti2', audioPath: '/audio/cmn/64k/syllabs/cmn-ti2.mp3', size: 9948 },
  { id: 'ti3', audioPath: '/audio/cmn/64k/syllabs/cmn-ti3.mp3', size: 12444 },
  { id: 'ti4', audioPath: '/audio/cmn/64k/syllabs/cmn-ti4.mp3', size: 8028 },
  {
    id: 'tian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tian1.mp3',
    size: 10720
  },
  {
    id: 'tian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tian2.mp3',
    size: 8416
  },
  {
    id: 'tian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tian3.mp3',
    size: 12064
  },
  {
    id: 'tian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tian4.mp3',
    size: 9184
  },
  {
    id: 'tiao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tiao1.mp3',
    size: 8416
  },
  {
    id: 'tiao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tiao2.mp3',
    size: 9184
  },
  {
    id: 'tiao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tiao3.mp3',
    size: 12832
  },
  {
    id: 'tiao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tiao4.mp3',
    size: 9184
  },
  { id: 'tie1', audioPath: '/audio/cmn/64k/syllabs/cmn-tie1.mp3', size: 9566 },
  { id: 'tie2', audioPath: '/audio/cmn/64k/syllabs/cmn-tie2.mp3', size: 8414 },
  { id: 'tie3', audioPath: '/audio/cmn/64k/syllabs/cmn-tie3.mp3', size: 10718 },
  { id: 'tie4', audioPath: '/audio/cmn/64k/syllabs/cmn-tie4.mp3', size: 9566 },
  {
    id: 'ting1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ting1.mp3',
    size: 9952
  },
  {
    id: 'ting2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ting2.mp3',
    size: 10336
  },
  {
    id: 'ting3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ting3.mp3',
    size: 12448
  },
  {
    id: 'ting4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ting4.mp3',
    size: 9568
  },
  {
    id: 'tong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tong1.mp3',
    size: 9952
  },
  {
    id: 'tong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tong2.mp3',
    size: 9184
  },
  {
    id: 'tong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tong3.mp3',
    size: 12064
  },
  {
    id: 'tong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tong4.mp3',
    size: 9184
  },
  { id: 'tou1', audioPath: '/audio/cmn/64k/syllabs/cmn-tou1.mp3', size: 9950 },
  { id: 'tou2', audioPath: '/audio/cmn/64k/syllabs/cmn-tou2.mp3', size: 9182 },
  { id: 'tou3', audioPath: '/audio/cmn/64k/syllabs/cmn-tou3.mp3', size: 12062 },
  { id: 'tou4', audioPath: '/audio/cmn/64k/syllabs/cmn-tou4.mp3', size: 9566 },
  { id: 'tu1', audioPath: '/audio/cmn/64k/syllabs/cmn-tu1.mp3', size: 9564 },
  { id: 'tu2', audioPath: '/audio/cmn/64k/syllabs/cmn-tu2.mp3', size: 8796 },
  { id: 'tu3', audioPath: '/audio/cmn/64k/syllabs/cmn-tu3.mp3', size: 11676 },
  { id: 'tu4', audioPath: '/audio/cmn/64k/syllabs/cmn-tu4.mp3', size: 8028 },
  {
    id: 'tuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tuan1.mp3',
    size: 10336
  },
  {
    id: 'tuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tuan2.mp3',
    size: 9568
  },
  {
    id: 'tuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tuan3.mp3',
    size: 11296
  },
  {
    id: 'tuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-tuan4.mp3',
    size: 8800
  },
  { id: 'tui1', audioPath: '/audio/cmn/64k/syllabs/cmn-tui1.mp3', size: 9950 },
  { id: 'tui2', audioPath: '/audio/cmn/64k/syllabs/cmn-tui2.mp3', size: 9566 },
  { id: 'tui3', audioPath: '/audio/cmn/64k/syllabs/cmn-tui3.mp3', size: 12446 },
  { id: 'tui4', audioPath: '/audio/cmn/64k/syllabs/cmn-tui4.mp3', size: 9182 },
  { id: 'tun1', audioPath: '/audio/cmn/64k/syllabs/cmn-tun1.mp3', size: 9950 },
  { id: 'tun2', audioPath: '/audio/cmn/64k/syllabs/cmn-tun2.mp3', size: 10334 },
  { id: 'tun3', audioPath: '/audio/cmn/64k/syllabs/cmn-tun3.mp3', size: 11678 },
  { id: 'tun4', audioPath: '/audio/cmn/64k/syllabs/cmn-tun4.mp3', size: 8798 },
  { id: 'tuo1', audioPath: '/audio/cmn/64k/syllabs/cmn-tuo1.mp3', size: 9950 },
  { id: 'tuo2', audioPath: '/audio/cmn/64k/syllabs/cmn-tuo2.mp3', size: 9566 },
  { id: 'tuo3', audioPath: '/audio/cmn/64k/syllabs/cmn-tuo3.mp3', size: 11294 },
  { id: 'tuo4', audioPath: '/audio/cmn/64k/syllabs/cmn-tuo4.mp3', size: 9182 },
  { id: 'wa1', audioPath: '/audio/cmn/64k/syllabs/cmn-wa1.mp3', size: 9948 },
  { id: 'wa2', audioPath: '/audio/cmn/64k/syllabs/cmn-wa2.mp3', size: 9948 },
  { id: 'wa3', audioPath: '/audio/cmn/64k/syllabs/cmn-wa3.mp3', size: 12060 },
  { id: 'wa4', audioPath: '/audio/cmn/64k/syllabs/cmn-wa4.mp3', size: 9564 },
  { id: 'wai1', audioPath: '/audio/cmn/64k/syllabs/cmn-wai1.mp3', size: 8798 },
  { id: 'wai2', audioPath: '/audio/cmn/64k/syllabs/cmn-wai2.mp3', size: 8414 },
  { id: 'wai3', audioPath: '/audio/cmn/64k/syllabs/cmn-wai3.mp3', size: 11678 },
  { id: 'wai4', audioPath: '/audio/cmn/64k/syllabs/cmn-wai4.mp3', size: 9182 },
  { id: 'wan1', audioPath: '/audio/cmn/64k/syllabs/cmn-wan1.mp3', size: 8414 },
  { id: 'wan2', audioPath: '/audio/cmn/64k/syllabs/cmn-wan2.mp3', size: 10334 },
  { id: 'wan3', audioPath: '/audio/cmn/64k/syllabs/cmn-wan3.mp3', size: 11678 },
  { id: 'wan4', audioPath: '/audio/cmn/64k/syllabs/cmn-wan4.mp3', size: 9950 },
  {
    id: 'wang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-wang1.mp3',
    size: 9568
  },
  {
    id: 'wang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-wang2.mp3',
    size: 10336
  },
  {
    id: 'wang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-wang3.mp3',
    size: 11296
  },
  {
    id: 'wang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-wang4.mp3',
    size: 9952
  },
  { id: 'wei1', audioPath: '/audio/cmn/64k/syllabs/cmn-wei1.mp3', size: 9566 },
  { id: 'wei2', audioPath: '/audio/cmn/64k/syllabs/cmn-wei2.mp3', size: 10334 },
  { id: 'wei3', audioPath: '/audio/cmn/64k/syllabs/cmn-wei3.mp3', size: 11678 },
  { id: 'wei4', audioPath: '/audio/cmn/64k/syllabs/cmn-wei4.mp3', size: 8798 },
  { id: 'wen1', audioPath: '/audio/cmn/64k/syllabs/cmn-wen1.mp3', size: 10334 },
  { id: 'wen2', audioPath: '/audio/cmn/64k/syllabs/cmn-wen2.mp3', size: 10334 },
  { id: 'wen3', audioPath: '/audio/cmn/64k/syllabs/cmn-wen3.mp3', size: 12062 },
  { id: 'wen4', audioPath: '/audio/cmn/64k/syllabs/cmn-wen4.mp3', size: 8798 },
  {
    id: 'weng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-weng1.mp3',
    size: 9952
  },
  {
    id: 'weng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-weng2.mp3',
    size: 9568
  },
  {
    id: 'weng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-weng3.mp3',
    size: 12064
  },
  {
    id: 'weng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-weng4.mp3',
    size: 9568
  },
  { id: 'wo1', audioPath: '/audio/cmn/64k/syllabs/cmn-wo1.mp3', size: 9564 },
  { id: 'wo2', audioPath: '/audio/cmn/64k/syllabs/cmn-wo2.mp3', size: 9180 },
  { id: 'wo3', audioPath: '/audio/cmn/64k/syllabs/cmn-wo3.mp3', size: 10716 },
  { id: 'wo4', audioPath: '/audio/cmn/64k/syllabs/cmn-wo4.mp3', size: 8796 },
  { id: 'wu1', audioPath: '/audio/cmn/64k/syllabs/cmn-wu1.mp3', size: 9180 },
  { id: 'wu2', audioPath: '/audio/cmn/64k/syllabs/cmn-wu2.mp3', size: 8412 },
  { id: 'wu3', audioPath: '/audio/cmn/64k/syllabs/cmn-wu3.mp3', size: 12444 },
  { id: 'wu4', audioPath: '/audio/cmn/64k/syllabs/cmn-wu4.mp3', size: 9180 },
  { id: 'xi1', audioPath: '/audio/cmn/64k/syllabs/cmn-xi1.mp3', size: 9564 },
  { id: 'xi2', audioPath: '/audio/cmn/64k/syllabs/cmn-xi2.mp3', size: 10332 },
  { id: 'xi3', audioPath: '/audio/cmn/64k/syllabs/cmn-xi3.mp3', size: 13980 },
  { id: 'xi4', audioPath: '/audio/cmn/64k/syllabs/cmn-xi4.mp3', size: 9564 },
  { id: 'xia1', audioPath: '/audio/cmn/64k/syllabs/cmn-xia1.mp3', size: 8798 },
  { id: 'xia2', audioPath: '/audio/cmn/64k/syllabs/cmn-xia2.mp3', size: 9566 },
  { id: 'xia3', audioPath: '/audio/cmn/64k/syllabs/cmn-xia3.mp3', size: 12062 },
  { id: 'xia4', audioPath: '/audio/cmn/64k/syllabs/cmn-xia4.mp3', size: 9950 },
  {
    id: 'xian1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xian1.mp3',
    size: 10720
  },
  {
    id: 'xian2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xian2.mp3',
    size: 10720
  },
  {
    id: 'xian3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xian3.mp3',
    size: 13984
  },
  {
    id: 'xian4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xian4.mp3',
    size: 9568
  },
  {
    id: 'xiang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiang1.mp3',
    size: 10722
  },
  {
    id: 'xiang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiang2.mp3',
    size: 10338
  },
  {
    id: 'xiang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiang3.mp3',
    size: 12834
  },
  {
    id: 'xiang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiang4.mp3',
    size: 10338
  },
  {
    id: 'xiao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiao1.mp3',
    size: 10720
  },
  {
    id: 'xiao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiao2.mp3',
    size: 11296
  },
  {
    id: 'xiao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiao3.mp3',
    size: 12832
  },
  {
    id: 'xiao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiao4.mp3',
    size: 9568
  },
  { id: 'xie1', audioPath: '/audio/cmn/64k/syllabs/cmn-xie1.mp3', size: 10718 },
  { id: 'xie2', audioPath: '/audio/cmn/64k/syllabs/cmn-xie2.mp3', size: 10334 },
  { id: 'xie3', audioPath: '/audio/cmn/64k/syllabs/cmn-xie3.mp3', size: 11678 },
  { id: 'xie4', audioPath: '/audio/cmn/64k/syllabs/cmn-xie4.mp3', size: 9950 },
  { id: 'xin1', audioPath: '/audio/cmn/64k/syllabs/cmn-xin1.mp3', size: 11294 },
  { id: 'xin2', audioPath: '/audio/cmn/64k/syllabs/cmn-xin2.mp3', size: 10334 },
  { id: 'xin3', audioPath: '/audio/cmn/64k/syllabs/cmn-xin3.mp3', size: 10718 },
  { id: 'xin4', audioPath: '/audio/cmn/64k/syllabs/cmn-xin4.mp3', size: 10334 },
  {
    id: 'xing1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xing1.mp3',
    size: 11296
  },
  {
    id: 'xing2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xing2.mp3',
    size: 9952
  },
  {
    id: 'xing3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xing3.mp3',
    size: 13216
  },
  {
    id: 'xing4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xing4.mp3',
    size: 10720
  },
  {
    id: 'xiong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiong1.mp3',
    size: 11298
  },
  {
    id: 'xiong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiong2.mp3',
    size: 9954
  },
  {
    id: 'xiong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiong3.mp3',
    size: 13218
  },
  {
    id: 'xiong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xiong4.mp3',
    size: 9186
  },
  { id: 'xiu1', audioPath: '/audio/cmn/64k/syllabs/cmn-xiu1.mp3', size: 9950 },
  { id: 'xiu2', audioPath: '/audio/cmn/64k/syllabs/cmn-xiu2.mp3', size: 10334 },
  { id: 'xiu3', audioPath: '/audio/cmn/64k/syllabs/cmn-xiu3.mp3', size: 11294 },
  { id: 'xiu4', audioPath: '/audio/cmn/64k/syllabs/cmn-xiu4.mp3', size: 9566 },
  { id: 'xu1', audioPath: '/audio/cmn/64k/syllabs/cmn-xu1.mp3', size: 10332 },
  { id: 'xu2', audioPath: '/audio/cmn/64k/syllabs/cmn-xu2.mp3', size: 9948 },
  { id: 'xu3', audioPath: '/audio/cmn/64k/syllabs/cmn-xu3.mp3', size: 13212 },
  { id: 'xu4', audioPath: '/audio/cmn/64k/syllabs/cmn-xu4.mp3', size: 9948 },
  {
    id: 'xuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xuan1.mp3',
    size: 10720
  },
  {
    id: 'xuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xuan2.mp3',
    size: 10720
  },
  {
    id: 'xuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xuan3.mp3',
    size: 14368
  },
  {
    id: 'xuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-xuan4.mp3',
    size: 10336
  },
  { id: 'xue1', audioPath: '/audio/cmn/64k/syllabs/cmn-xue1.mp3', size: 10334 },
  { id: 'xue2', audioPath: '/audio/cmn/64k/syllabs/cmn-xue2.mp3', size: 9182 },
  { id: 'xue3', audioPath: '/audio/cmn/64k/syllabs/cmn-xue3.mp3', size: 12830 },
  { id: 'xue4', audioPath: '/audio/cmn/64k/syllabs/cmn-xue4.mp3', size: 9566 },
  { id: 'xun1', audioPath: '/audio/cmn/64k/syllabs/cmn-xun1.mp3', size: 9566 },
  { id: 'xun2', audioPath: '/audio/cmn/64k/syllabs/cmn-xun2.mp3', size: 9950 },
  { id: 'xun3', audioPath: '/audio/cmn/64k/syllabs/cmn-xun3.mp3', size: 13982 },
  { id: 'xun4', audioPath: '/audio/cmn/64k/syllabs/cmn-xun4.mp3', size: 10718 },
  { id: 'ya1', audioPath: '/audio/cmn/64k/syllabs/cmn-ya1.mp3', size: 9948 },
  { id: 'ya2', audioPath: '/audio/cmn/64k/syllabs/cmn-ya2.mp3', size: 9948 },
  { id: 'ya3', audioPath: '/audio/cmn/64k/syllabs/cmn-ya3.mp3', size: 13212 },
  { id: 'ya4', audioPath: '/audio/cmn/64k/syllabs/cmn-ya4.mp3', size: 9180 },
  { id: 'yai1', audioPath: '/audio/cmn/64k/syllabs/cmn-yai1.mp3', size: 9182 },
  { id: 'yai2', audioPath: '/audio/cmn/64k/syllabs/cmn-yai2.mp3', size: 9566 },
  { id: 'yai3', audioPath: '/audio/cmn/64k/syllabs/cmn-yai3.mp3', size: 12446 },
  { id: 'yai4', audioPath: '/audio/cmn/64k/syllabs/cmn-yai4.mp3', size: 8414 },
  { id: 'yan1', audioPath: '/audio/cmn/64k/syllabs/cmn-yan1.mp3', size: 9566 },
  { id: 'yan2', audioPath: '/audio/cmn/64k/syllabs/cmn-yan2.mp3', size: 9182 },
  { id: 'yan3', audioPath: '/audio/cmn/64k/syllabs/cmn-yan3.mp3', size: 10334 },
  { id: 'yan4', audioPath: '/audio/cmn/64k/syllabs/cmn-yan4.mp3', size: 9566 },
  {
    id: 'yang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yang1.mp3',
    size: 9952
  },
  {
    id: 'yang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yang2.mp3',
    size: 8800
  },
  {
    id: 'yang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yang3.mp3',
    size: 12448
  },
  {
    id: 'yang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yang4.mp3',
    size: 9184
  },
  { id: 'yao1', audioPath: '/audio/cmn/64k/syllabs/cmn-yao1.mp3', size: 8414 },
  { id: 'yao2', audioPath: '/audio/cmn/64k/syllabs/cmn-yao2.mp3', size: 9566 },
  { id: 'yao3', audioPath: '/audio/cmn/64k/syllabs/cmn-yao3.mp3', size: 10718 },
  { id: 'yao4', audioPath: '/audio/cmn/64k/syllabs/cmn-yao4.mp3', size: 10334 },
  { id: 'ye1', audioPath: '/audio/cmn/64k/syllabs/cmn-ye1.mp3', size: 9564 },
  { id: 'ye2', audioPath: '/audio/cmn/64k/syllabs/cmn-ye2.mp3', size: 9564 },
  { id: 'ye3', audioPath: '/audio/cmn/64k/syllabs/cmn-ye3.mp3', size: 10716 },
  { id: 'ye4', audioPath: '/audio/cmn/64k/syllabs/cmn-ye4.mp3', size: 8796 },
  { id: 'yi1', audioPath: '/audio/cmn/64k/syllabs/cmn-yi1.mp3', size: 9180 },
  { id: 'yi2', audioPath: '/audio/cmn/64k/syllabs/cmn-yi2.mp3', size: 9564 },
  { id: 'yi3', audioPath: '/audio/cmn/64k/syllabs/cmn-yi3.mp3', size: 11292 },
  { id: 'yi4', audioPath: '/audio/cmn/64k/syllabs/cmn-yi4.mp3', size: 8796 },
  { id: 'yin1', audioPath: '/audio/cmn/64k/syllabs/cmn-yin1.mp3', size: 9182 },
  { id: 'yin2', audioPath: '/audio/cmn/64k/syllabs/cmn-yin2.mp3', size: 9950 },
  { id: 'yin3', audioPath: '/audio/cmn/64k/syllabs/cmn-yin3.mp3', size: 11678 },
  { id: 'yin4', audioPath: '/audio/cmn/64k/syllabs/cmn-yin4.mp3', size: 9182 },
  {
    id: 'ying1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ying1.mp3',
    size: 10336
  },
  {
    id: 'ying2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ying2.mp3',
    size: 10336
  },
  {
    id: 'ying3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ying3.mp3',
    size: 10720
  },
  {
    id: 'ying4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-ying4.mp3',
    size: 8800
  },
  {
    id: 'yong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yong1.mp3',
    size: 9568
  },
  {
    id: 'yong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yong2.mp3',
    size: 9568
  },
  {
    id: 'yong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yong3.mp3',
    size: 10720
  },
  {
    id: 'yong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yong4.mp3',
    size: 9568
  },
  { id: 'you1', audioPath: '/audio/cmn/64k/syllabs/cmn-you1.mp3', size: 9566 },
  { id: 'you2', audioPath: '/audio/cmn/64k/syllabs/cmn-you2.mp3', size: 9566 },
  { id: 'you3', audioPath: '/audio/cmn/64k/syllabs/cmn-you3.mp3', size: 12062 },
  { id: 'you4', audioPath: '/audio/cmn/64k/syllabs/cmn-you4.mp3', size: 9182 },
  { id: 'yu1', audioPath: '/audio/cmn/64k/syllabs/cmn-yu1.mp3', size: 8412 },
  { id: 'yu2', audioPath: '/audio/cmn/64k/syllabs/cmn-yu2.mp3', size: 8412 },
  { id: 'yu3', audioPath: '/audio/cmn/64k/syllabs/cmn-yu3.mp3', size: 10332 },
  { id: 'yu4', audioPath: '/audio/cmn/64k/syllabs/cmn-yu4.mp3', size: 9180 },
  {
    id: 'yuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yuan1.mp3',
    size: 9952
  },
  {
    id: 'yuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yuan2.mp3',
    size: 10336
  },
  {
    id: 'yuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yuan3.mp3',
    size: 12448
  },
  {
    id: 'yuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-yuan4.mp3',
    size: 8416
  },
  { id: 'yue1', audioPath: '/audio/cmn/64k/syllabs/cmn-yue1.mp3', size: 8414 },
  { id: 'yue2', audioPath: '/audio/cmn/64k/syllabs/cmn-yue2.mp3', size: 9566 },
  { id: 'yue3', audioPath: '/audio/cmn/64k/syllabs/cmn-yue3.mp3', size: 11678 },
  { id: 'yue4', audioPath: '/audio/cmn/64k/syllabs/cmn-yue4.mp3', size: 8798 },
  { id: 'yun1', audioPath: '/audio/cmn/64k/syllabs/cmn-yun1.mp3', size: 9182 },
  { id: 'yun2', audioPath: '/audio/cmn/64k/syllabs/cmn-yun2.mp3', size: 10334 },
  { id: 'yun3', audioPath: '/audio/cmn/64k/syllabs/cmn-yun3.mp3', size: 10334 },
  { id: 'yun4', audioPath: '/audio/cmn/64k/syllabs/cmn-yun4.mp3', size: 9182 },
  { id: 'za1', audioPath: '/audio/cmn/64k/syllabs/cmn-za1.mp3', size: 9948 },
  { id: 'za2', audioPath: '/audio/cmn/64k/syllabs/cmn-za2.mp3', size: 9180 },
  { id: 'za3', audioPath: '/audio/cmn/64k/syllabs/cmn-za3.mp3', size: 11292 },
  { id: 'za4', audioPath: '/audio/cmn/64k/syllabs/cmn-za4.mp3', size: 9564 },
  { id: 'zai1', audioPath: '/audio/cmn/64k/syllabs/cmn-zai1.mp3', size: 9566 },
  { id: 'zai2', audioPath: '/audio/cmn/64k/syllabs/cmn-zai2.mp3', size: 9182 },
  { id: 'zai3', audioPath: '/audio/cmn/64k/syllabs/cmn-zai3.mp3', size: 12446 },
  { id: 'zai4', audioPath: '/audio/cmn/64k/syllabs/cmn-zai4.mp3', size: 9182 },
  { id: 'zan1', audioPath: '/audio/cmn/64k/syllabs/cmn-zan1.mp3', size: 8414 },
  { id: 'zan2', audioPath: '/audio/cmn/64k/syllabs/cmn-zan2.mp3', size: 10334 },
  { id: 'zan3', audioPath: '/audio/cmn/64k/syllabs/cmn-zan3.mp3', size: 11294 },
  { id: 'zan4', audioPath: '/audio/cmn/64k/syllabs/cmn-zan4.mp3', size: 8798 },
  {
    id: 'zang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zang1.mp3',
    size: 9568
  },
  {
    id: 'zang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zang2.mp3',
    size: 8800
  },
  {
    id: 'zang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zang3.mp3',
    size: 12064
  },
  {
    id: 'zang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zang4.mp3',
    size: 8800
  },
  { id: 'zao1', audioPath: '/audio/cmn/64k/syllabs/cmn-zao1.mp3', size: 9182 },
  { id: 'zao2', audioPath: '/audio/cmn/64k/syllabs/cmn-zao2.mp3', size: 9566 },
  { id: 'zao3', audioPath: '/audio/cmn/64k/syllabs/cmn-zao3.mp3', size: 12062 },
  { id: 'zao4', audioPath: '/audio/cmn/64k/syllabs/cmn-zao4.mp3', size: 9182 },
  { id: 'ze1', audioPath: '/audio/cmn/64k/syllabs/cmn-ze1.mp3', size: 9564 },
  { id: 'ze2', audioPath: '/audio/cmn/64k/syllabs/cmn-ze2.mp3', size: 9564 },
  { id: 'ze3', audioPath: '/audio/cmn/64k/syllabs/cmn-ze3.mp3', size: 10332 },
  { id: 'ze4', audioPath: '/audio/cmn/64k/syllabs/cmn-ze4.mp3', size: 9180 },
  { id: 'zei1', audioPath: '/audio/cmn/64k/syllabs/cmn-zei1.mp3', size: 9182 },
  { id: 'zei2', audioPath: '/audio/cmn/64k/syllabs/cmn-zei2.mp3', size: 9950 },
  { id: 'zei3', audioPath: '/audio/cmn/64k/syllabs/cmn-zei3.mp3', size: 10334 },
  { id: 'zei4', audioPath: '/audio/cmn/64k/syllabs/cmn-zei4.mp3', size: 8414 },
  { id: 'zen1', audioPath: '/audio/cmn/64k/syllabs/cmn-zen1.mp3', size: 9566 },
  { id: 'zen2', audioPath: '/audio/cmn/64k/syllabs/cmn-zen2.mp3', size: 9566 },
  { id: 'zen3', audioPath: '/audio/cmn/64k/syllabs/cmn-zen3.mp3', size: 11294 },
  { id: 'zen4', audioPath: '/audio/cmn/64k/syllabs/cmn-zen4.mp3', size: 9182 },
  {
    id: 'zeng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zeng1.mp3',
    size: 8800
  },
  {
    id: 'zeng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zeng2.mp3',
    size: 9568
  },
  {
    id: 'zeng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zeng3.mp3',
    size: 12064
  },
  {
    id: 'zeng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zeng4.mp3',
    size: 8032
  },
  { id: 'zha1', audioPath: '/audio/cmn/64k/syllabs/cmn-zha1.mp3', size: 8030 },
  { id: 'zha2', audioPath: '/audio/cmn/64k/syllabs/cmn-zha2.mp3', size: 9566 },
  { id: 'zha3', audioPath: '/audio/cmn/64k/syllabs/cmn-zha3.mp3', size: 11678 },
  { id: 'zha4', audioPath: '/audio/cmn/64k/syllabs/cmn-zha4.mp3', size: 9182 },
  {
    id: 'zhai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhai1.mp3',
    size: 9184
  },
  {
    id: 'zhai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhai2.mp3',
    size: 9568
  },
  {
    id: 'zhai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhai3.mp3',
    size: 12448
  },
  {
    id: 'zhai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhai4.mp3',
    size: 9952
  },
  {
    id: 'zhan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhan1.mp3',
    size: 9184
  },
  {
    id: 'zhan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhan2.mp3',
    size: 9568
  },
  {
    id: 'zhan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhan3.mp3',
    size: 12448
  },
  {
    id: 'zhan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhan4.mp3',
    size: 9952
  },
  {
    id: 'zhang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhang1.mp3',
    size: 9186
  },
  {
    id: 'zhang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhang2.mp3',
    size: 9954
  },
  {
    id: 'zhang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhang3.mp3',
    size: 10722
  },
  {
    id: 'zhang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhang4.mp3',
    size: 9186
  },
  {
    id: 'zhao1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhao1.mp3',
    size: 9952
  },
  {
    id: 'zhao2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhao2.mp3',
    size: 9952
  },
  {
    id: 'zhao3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhao3.mp3',
    size: 12448
  },
  {
    id: 'zhao4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhao4.mp3',
    size: 8032
  },
  { id: 'zhe1', audioPath: '/audio/cmn/64k/syllabs/cmn-zhe1.mp3', size: 9566 },
  { id: 'zhe2', audioPath: '/audio/cmn/64k/syllabs/cmn-zhe2.mp3', size: 8798 },
  { id: 'zhe3', audioPath: '/audio/cmn/64k/syllabs/cmn-zhe3.mp3', size: 13214 },
  { id: 'zhe4', audioPath: '/audio/cmn/64k/syllabs/cmn-zhe4.mp3', size: 8414 },
  {
    id: 'zhei1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhei1.mp3',
    size: 9184
  },
  {
    id: 'zhei2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhei2.mp3',
    size: 8800
  },
  {
    id: 'zhei3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhei3.mp3',
    size: 11296
  },
  {
    id: 'zhei4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhei4.mp3',
    size: 9184
  },
  {
    id: 'zhen1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhen1.mp3',
    size: 9184
  },
  {
    id: 'zhen2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhen2.mp3',
    size: 8800
  },
  {
    id: 'zhen3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhen3.mp3',
    size: 12064
  },
  {
    id: 'zhen4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhen4.mp3',
    size: 8416
  },
  {
    id: 'zheng1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zheng1.mp3',
    size: 8418
  },
  {
    id: 'zheng2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zheng2.mp3',
    size: 9954
  },
  {
    id: 'zheng3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zheng3.mp3',
    size: 12450
  },
  {
    id: 'zheng4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zheng4.mp3',
    size: 9186
  },
  { id: 'zhi1', audioPath: '/audio/cmn/64k/syllabs/cmn-zhi1.mp3', size: 9566 },
  { id: 'zhi2', audioPath: '/audio/cmn/64k/syllabs/cmn-zhi2.mp3', size: 9566 },
  { id: 'zhi3', audioPath: '/audio/cmn/64k/syllabs/cmn-zhi3.mp3', size: 11294 },
  { id: 'zhi4', audioPath: '/audio/cmn/64k/syllabs/cmn-zhi4.mp3', size: 8414 },
  {
    id: 'zhong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhong1.mp3',
    size: 9570
  },
  {
    id: 'zhong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhong2.mp3',
    size: 9570
  },
  {
    id: 'zhong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhong3.mp3',
    size: 11682
  },
  {
    id: 'zhong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhong4.mp3',
    size: 8418
  },
  {
    id: 'zhou1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhou1.mp3',
    size: 8416
  },
  {
    id: 'zhou2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhou2.mp3',
    size: 8800
  },
  {
    id: 'zhou3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhou3.mp3',
    size: 12064
  },
  {
    id: 'zhou4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhou4.mp3',
    size: 8800
  },
  { id: 'zhu1', audioPath: '/audio/cmn/64k/syllabs/cmn-zhu1.mp3', size: 8798 },
  { id: 'zhu2', audioPath: '/audio/cmn/64k/syllabs/cmn-zhu2.mp3', size: 8798 },
  { id: 'zhu3', audioPath: '/audio/cmn/64k/syllabs/cmn-zhu3.mp3', size: 11678 },
  { id: 'zhu4', audioPath: '/audio/cmn/64k/syllabs/cmn-zhu4.mp3', size: 8030 },
  {
    id: 'zhua1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhua1.mp3',
    size: 9952
  },
  {
    id: 'zhua2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhua2.mp3',
    size: 9568
  },
  {
    id: 'zhua3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhua3.mp3',
    size: 11296
  },
  {
    id: 'zhua4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhua4.mp3',
    size: 8800
  },
  {
    id: 'zhuai1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuai1.mp3',
    size: 9570
  },
  {
    id: 'zhuai2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuai2.mp3',
    size: 10338
  },
  {
    id: 'zhuai3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuai3.mp3',
    size: 12450
  },
  {
    id: 'zhuai4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuai4.mp3',
    size: 9186
  },
  {
    id: 'zhuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuan1.mp3',
    size: 9570
  },
  {
    id: 'zhuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuan2.mp3',
    size: 9186
  },
  {
    id: 'zhuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuan3.mp3',
    size: 12834
  },
  {
    id: 'zhuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuan4.mp3',
    size: 9570
  },
  {
    id: 'zhuang1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuang1.mp3',
    size: 10340
  },
  {
    id: 'zhuang2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuang2.mp3',
    size: 9956
  },
  {
    id: 'zhuang3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuang3.mp3',
    size: 11300
  },
  {
    id: 'zhuang4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuang4.mp3',
    size: 8420
  },
  {
    id: 'zhui1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhui1.mp3',
    size: 9568
  },
  {
    id: 'zhui2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhui2.mp3',
    size: 9568
  },
  {
    id: 'zhui3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhui3.mp3',
    size: 12064
  },
  {
    id: 'zhui4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhui4.mp3',
    size: 8800
  },
  {
    id: 'zhun1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhun1.mp3',
    size: 10336
  },
  {
    id: 'zhun2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhun2.mp3',
    size: 8416
  },
  {
    id: 'zhun3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhun3.mp3',
    size: 12448
  },
  {
    id: 'zhun4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhun4.mp3',
    size: 9184
  },
  {
    id: 'zhuo1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuo1.mp3',
    size: 8800
  },
  {
    id: 'zhuo2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuo2.mp3',
    size: 9568
  },
  {
    id: 'zhuo3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuo3.mp3',
    size: 10336
  },
  {
    id: 'zhuo4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zhuo4.mp3',
    size: 9184
  },
  { id: 'zi1', audioPath: '/audio/cmn/64k/syllabs/cmn-zi1.mp3', size: 9180 },
  { id: 'zi2', audioPath: '/audio/cmn/64k/syllabs/cmn-zi2.mp3', size: 9564 },
  { id: 'zi3', audioPath: '/audio/cmn/64k/syllabs/cmn-zi3.mp3', size: 12444 },
  { id: 'zi4', audioPath: '/audio/cmn/64k/syllabs/cmn-zi4.mp3', size: 9564 },
  {
    id: 'zong1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zong1.mp3',
    size: 9952
  },
  {
    id: 'zong2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zong2.mp3',
    size: 9952
  },
  {
    id: 'zong3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zong3.mp3',
    size: 12448
  },
  {
    id: 'zong4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zong4.mp3',
    size: 9568
  },
  { id: 'zou1', audioPath: '/audio/cmn/64k/syllabs/cmn-zou1.mp3', size: 9950 },
  { id: 'zou2', audioPath: '/audio/cmn/64k/syllabs/cmn-zou2.mp3', size: 9950 },
  { id: 'zou3', audioPath: '/audio/cmn/64k/syllabs/cmn-zou3.mp3', size: 12446 },
  { id: 'zou4', audioPath: '/audio/cmn/64k/syllabs/cmn-zou4.mp3', size: 9182 },
  { id: 'zu1', audioPath: '/audio/cmn/64k/syllabs/cmn-zu1.mp3', size: 9948 },
  { id: 'zu2', audioPath: '/audio/cmn/64k/syllabs/cmn-zu2.mp3', size: 9564 },
  { id: 'zu3', audioPath: '/audio/cmn/64k/syllabs/cmn-zu3.mp3', size: 11676 },
  { id: 'zu4', audioPath: '/audio/cmn/64k/syllabs/cmn-zu4.mp3', size: 9180 },
  {
    id: 'zuan1',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zuan1.mp3',
    size: 10336
  },
  {
    id: 'zuan2',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zuan2.mp3',
    size: 8416
  },
  {
    id: 'zuan3',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zuan3.mp3',
    size: 9952
  },
  {
    id: 'zuan4',
    audioPath: '/audio/cmn/64k/syllabs/cmn-zuan4.mp3',
    size: 9952
  },
  { id: 'zui1', audioPath: '/audio/cmn/64k/syllabs/cmn-zui1.mp3', size: 8414 },
  { id: 'zui2', audioPath: '/audio/cmn/64k/syllabs/cmn-zui2.mp3', size: 9566 },
  { id: 'zui3', audioPath: '/audio/cmn/64k/syllabs/cmn-zui3.mp3', size: 12830 },
  { id: 'zui4', audioPath: '/audio/cmn/64k/syllabs/cmn-zui4.mp3', size: 9182 },
  { id: 'zun1', audioPath: '/audio/cmn/64k/syllabs/cmn-zun1.mp3', size: 9950 },
  { id: 'zun2', audioPath: '/audio/cmn/64k/syllabs/cmn-zun2.mp3', size: 9566 },
  { id: 'zun3', audioPath: '/audio/cmn/64k/syllabs/cmn-zun3.mp3', size: 12830 },
  { id: 'zun4', audioPath: '/audio/cmn/64k/syllabs/cmn-zun4.mp3', size: 8414 },
  { id: 'zuo1', audioPath: '/audio/cmn/64k/syllabs/cmn-zuo1.mp3', size: 9566 },
  { id: 'zuo2', audioPath: '/audio/cmn/64k/syllabs/cmn-zuo2.mp3', size: 9182 },
  { id: 'zuo3', audioPath: '/audio/cmn/64k/syllabs/cmn-zuo3.mp3', size: 9950 },
  { id: 'zuo4', audioPath: '/audio/cmn/64k/syllabs/cmn-zuo4.mp3', size: 8798 }
] satisfies PronunciationSyllableAudioEntry[]
